<template>
  <svg
    width="525"
    height="539"
    viewBox="0 0 525 539"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="525"
      height="539"
    >
      <rect width="525" height="539" fill="white" />
    </mask>
    <g mask="url(#mask0)">
      <ellipse
        opacity="0.2"
        cx="260.571"
        cy="478.482"
        rx="234.394"
        ry="12.586"
        fill="#71ABDE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M238.787 288.478C238.787 288.478 256.759 285.562 265.704 288.782C272.176 291.11 279.944 296.667 282.028 313.454C282.028 313.454 260.63 319.754 238.789 319.961C238.787 319.963 235.427 300.333 238.787 288.478Z"
        fill="#F3AE92"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M255.027 318.82C255.603 313.864 256.119 305.508 253.906 300.459C252.086 296.3 245.999 292.846 238.06 291.68C235.971 303.554 238.778 319.96 238.778 319.96C244.211 319.885 249.636 319.505 255.027 318.82H255.027Z"
        fill="#EB7C74"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M265.704 288.781C261.356 287.531 256.828 287.025 252.312 287.285C256.768 287.482 270.95 290.908 275.062 300.366C276.884 304.843 278.176 309.517 278.913 314.294C280.898 313.784 282.028 313.454 282.028 313.454C279.942 296.666 272.173 291.111 265.704 288.781Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M105.11 308.865C96.7601 306.311 97.2109 305.866 89.5123 303.081C81.8136 300.297 80.8154 300.001 74.1893 297.539C67.5633 295.076 44.0991 291.852 33.7056 322.349C22.9928 353.778 34.9249 364.033 41.9306 369.23C52.8057 377.298 77.9525 386.438 85.2326 389.418C85.2311 389.418 70.9677 337.877 105.11 308.865Z"
        fill="#F29297"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M105.11 308.865C96.7601 306.311 97.2109 305.866 89.5123 303.081C81.8136 300.297 80.8154 300.001 74.1893 297.539C67.5633 295.076 44.0991 291.852 33.7056 322.349C22.9928 353.778 34.9249 364.033 41.9306 369.23C52.8057 377.298 77.9525 386.438 85.2326 389.418C85.2311 389.418 70.9677 337.877 105.11 308.865Z"
        fill="#F29297"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M103.394 309.393C92.1943 306.393 76.968 300.301 71.6717 298.978C66.3753 297.655 58.4304 298.05 54.0611 301.759C49.6917 305.467 60.4382 301.718 73.279 306.088C86.1198 310.457 91.5266 313.068 95.8035 314.709C100.08 316.35 103.394 309.393 103.394 309.393Z"
        fill="#F5A9A7"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M67.2692 336.242C59.6854 332.794 51.417 329.329 46.5491 323.904C36.6693 312.893 44.4645 304.024 50.6315 299.684C44.1733 303.286 37.8832 310.09 33.7056 322.348C22.9928 353.777 34.925 364.032 41.9292 369.229C52.8059 377.297 77.9526 386.437 85.2327 389.417C85.2327 389.417 79.1104 367.287 84.4935 343.866C78.5546 341.313 72.795 338.753 67.2692 336.242Z"
        fill="#EC6469"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.7386 306.09C38.662 310.846 35.5882 316.377 33.7017 322.351C22.9889 353.779 34.921 364.035 41.9253 369.231C52.802 377.299 77.9487 386.44 85.2288 389.419C83.2733 381.37 82.2864 373.116 82.2886 364.833C70.4997 360.111 59.1503 354.359 48.3725 347.643C25.5649 332.738 41.4044 308.085 42.7386 306.09Z"
        fill="#E73555"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M133.513 403.466C132.76 404.49 131.536 405.057 130.269 404.97C127.439 404.922 121.804 402.182 107.377 397.635C95.7783 393.98 88.5082 392.521 86.334 390.576C80.9174 385.732 74.1876 367.53 79.1436 344.678C83.7777 323.315 97.8336 311.973 102.664 309.711C106.619 307.859 110.894 308.247 118.992 310.66C123.891 312.12 128.88 313.261 133.927 314.078C136.805 314.545 139.562 314.884 142.165 315.123C149.018 315.751 147.748 318.306 147.748 318.306C147.748 318.306 124.102 327.119 118.691 352.898C111.876 385.363 133.513 403.466 133.513 403.466Z"
        fill="#16A461"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M103.393 309.395C103.148 309.491 102.903 309.596 102.66 309.711C100.148 311.044 97.8381 312.727 95.7998 314.71C106.187 318.829 116.818 322.303 127.632 325.114C127.633 325.114 133.717 324.531 138.347 323.567C140 322.396 141.546 321.437 142.887 320.677C141.59 320.023 140.2 319.572 138.766 319.342C127.119 316.838 110.504 311.665 103.393 309.395Z"
        fill="#3EC664"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M79.8296 341.939C79.5902 342.841 79.348 343.736 79.1436 344.676C74.1876 367.529 80.9174 385.731 86.334 390.577C88.5082 392.521 95.7797 393.982 107.377 397.636C121.804 402.183 127.439 404.924 130.269 404.97C131.536 405.057 132.76 404.49 133.513 403.467C133.513 403.467 113.897 387.031 117.922 357.414C104.694 352.53 91.8415 347.223 79.8296 341.939Z"
        fill="#16935D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M130.27 404.969C131.537 405.056 132.761 404.489 133.514 403.465C127.821 398.126 123.462 391.526 120.787 384.194L109.727 374.996C109.727 374.996 94.5911 370.243 77.4551 362.801C77.9045 376.778 82.4573 387.103 86.338 390.574C88.5122 392.519 95.7838 393.977 107.381 397.633C121.806 402.181 127.441 404.923 130.27 404.969Z"
        fill="#0E7F4C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M98.588 351.901C103.495 322.874 129.891 314.615 133.129 313.937C128.718 313.191 124.352 312.197 120.053 310.961H120.033C115.606 311.45 92.9333 321.741 88.8411 347.753C84.8749 372.953 94.9802 391.24 98.5389 394.979C101.125 395.727 104.068 396.588 107.377 397.629C109.022 398.149 110.538 398.639 111.964 399.109C111.964 399.109 93.8743 379.785 98.588 351.901Z"
        fill="#FFD348"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M114.641 312.881C111.527 314.414 108.593 316.289 105.894 318.471C109.245 319.655 112.933 320.893 116.776 322.075C119.816 319.806 123.092 317.871 126.546 316.304C122.472 315.194 118.366 314.001 114.641 312.881Z"
        fill="#FFE568"
      />
      <g style="mix-blend-mode:multiply" opacity="0.1">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M111.958 399.114H111.966C111.966 399.114 93.8743 379.784 98.588 351.902C98.6958 351.267 98.8245 350.656 98.952 350.042C95.647 348.697 92.3856 347.344 89.1674 345.982C89.0525 346.57 88.9363 347.16 88.8411 347.766C84.8749 372.966 94.9802 391.253 98.5389 394.992L98.5613 395.001L100.17 395.467L100.764 395.64L102.154 396.049L102.887 396.268C103.377 396.408 103.881 396.567 104.391 396.721L105.078 396.928C105.825 397.158 106.588 397.393 107.376 397.641C108.207 397.904 109.005 398.159 109.774 398.407C110.543 398.655 111.257 398.881 111.958 399.114Z"
          fill="#E85D1C"
        />
      </g>
      <g style="mix-blend-mode:multiply" opacity="0.3">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M109.781 398.401C110.518 398.638 111.224 398.869 111.911 399.101L111.962 399.117H111.97C105.205 391.133 100.641 381.521 98.7302 371.231C95.7021 370.136 92.1937 368.826 88.3926 367.328C90.0725 382.149 95.9904 392.306 98.5426 394.988H98.5566L100.161 395.453H100.175L100.602 395.577C101.244 395.764 101.906 395.959 102.587 396.162L102.892 396.254L104.378 396.701H104.392L105.079 396.909C105.824 397.137 106.586 397.372 107.372 397.62C108.204 397.883 109.002 398.138 109.771 398.386L109.781 398.401Z"
          fill="#E85D1C"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M385.967 282.193C385.967 282.193 381.648 280.636 365.506 286.896C349.364 293.155 254.812 325.994 147.751 318.305C147.751 318.305 125.678 315.281 112.171 346.386C98.6642 377.491 124.918 399.515 124.918 399.515C124.918 399.515 161.661 420.488 250.349 424.601C335.652 428.558 376.798 419.001 394.866 414.381C413.615 409.589 420.041 405.767 421.136 403.352C422.18 401.035 385.967 282.193 385.967 282.193Z"
        fill="#FFD348"
      />
      <g style="mix-blend-mode:multiply" opacity="0.1">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M215.766 378.996C182.808 378.907 144.459 367.762 109.524 354.254C103.026 381.134 124.911 399.516 124.911 399.516C124.911 399.516 161.656 420.489 250.341 424.603C335.645 428.559 376.791 419.003 394.859 414.383C413.608 409.59 420.034 405.768 421.129 403.353C421.395 402.767 419.256 394.655 415.92 382.891L350.303 367.525C350.303 367.525 291.634 379.203 215.766 378.996Z"
          fill="#E85D1C"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M385.965 282.193C385.965 282.193 381.647 280.636 365.504 286.896C349.36 293.155 254.807 325.994 147.743 318.305C147.743 318.305 129.108 315.775 115.606 339.497C204.561 369.133 307.364 346.386 340.185 336.005L387.674 320.34L394.782 311.319C389.725 294.527 385.965 282.193 385.965 282.193Z"
        fill="#FFDA60"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M363.743 302.994C363.743 302.994 387.618 284.721 379.621 286.485C371.624 288.249 336.68 305.711 263.681 317.534C222.351 324.197 180.271 324.806 138.766 319.34C134.722 320.54 130.945 322.499 127.635 325.113C145.93 329.429 180.929 336.003 228.877 332.794C305.77 327.654 350.113 308.796 363.743 302.994Z"
        fill="#FFE568"
      />
      <path
        d="M115.606 339.497C204.561 369.134 307.364 346.387 340.185 336.006"
        stroke="#FFEAA8"
        stroke-width="3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M359.592 389.083C345.349 394.138 235.864 418.44 109.727 374.998C112.413 384.422 117.671 392.912 124.911 399.516C124.911 399.516 161.654 420.489 250.341 424.602C335.645 428.559 376.791 419.002 394.859 414.383C413.608 409.59 420.034 405.768 421.129 403.353C421.466 402.609 417.934 389.759 412.993 372.693L359.592 389.083Z"
        fill="#FECB2F"
      />
      <g style="mix-blend-mode:multiply" opacity="0.3">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M421.13 403.349C421.034 401.901 420.763 400.469 420.322 399.086L390.443 397.709C355.939 413.373 207.225 433.097 109.728 374.998C110.932 379.482 112.785 383.765 115.23 387.712C117.86 392.1 121.122 396.077 124.911 399.516C124.911 399.516 161.654 420.49 250.341 424.603C335.644 428.559 376.79 419.003 394.859 414.383C413.609 409.587 420.035 405.763 421.13 403.349Z"
          fill="#E85D1C"
        />
      </g>
      <path
        d="M359.592 389.083C345.349 394.139 235.864 418.44 109.727 374.998"
        stroke="#FFE568"
        stroke-width="3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M146.25 357.438C138.881 355.85 135.304 355.038 130.046 354.161C120.902 352.636 119.712 364.609 126.779 368.581C132.26 371.624 138.183 373.791 144.334 375.002C147.961 375.819 151.678 376.169 155.394 376.043C158.944 375.852 162.254 373.755 163.052 370.573C164.109 366.657 162.153 362.556 158.444 360.913C154.514 359.328 150.426 358.163 146.25 357.438Z"
        fill="#16A461"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M126.778 368.577C132.259 371.621 138.182 373.788 144.333 374.999C147.96 375.816 151.677 376.166 155.393 376.04C158.491 375.996 161.31 374.244 162.721 371.485C149.253 368.113 135.659 363.823 122.388 359.055C121.673 362.84 123.435 366.663 126.778 368.577Z"
        fill="#16935D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M151.298 372.931C150.458 372.868 150.046 372.83 149.219 372.742C148.379 371.843 147.97 371.387 147.186 370.463C142.577 364.925 140.898 362.07 137.923 361.034C135.917 360.334 133.684 360.411 132.394 362.914C131.764 364.28 131.748 365.849 132.347 367.228C131.358 367.18 130.862 367.146 129.871 367.058C129.207 365.196 129.394 363.136 130.383 361.425C131.937 358.496 135.475 357.245 138.524 358.546C142.006 359.764 144.111 362.906 147.852 367.443C148.39 368.129 148.666 368.469 149.234 369.141L149.305 369.15C150.029 365.811 150.333 364.135 150.816 360.785C151.746 360.877 152.216 360.914 153.154 360.965C152.773 364.987 152.153 368.983 151.298 372.931L151.298 372.931Z"
        fill="#FFD348"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M385.967 282.192C381.767 283.312 368.384 296.518 359.262 308.631C350.139 320.744 340.85 331.031 340.185 336.005C339.52 340.979 346.986 358.232 350.303 367.521C353.62 376.809 358.1 387.261 359.592 389.081C361.085 390.901 381.985 395.381 390.444 397.706C398.903 400.031 418.144 404.006 421.13 403.347C424.117 402.687 452.665 372.591 467.084 352.867C477.934 338.181 487.844 322.823 496.754 306.885C497.915 304.397 497.929 299.843 491.791 298.848C485.653 297.852 457.785 294.315 435.727 290.886C415.087 287.68 390.61 280.96 385.967 282.192Z"
        fill="#F8E9D0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M494.462 299.672C493.619 299.264 492.719 298.986 491.792 298.849C485.656 297.854 457.786 294.316 435.728 290.887C415.087 287.679 390.611 280.96 385.966 282.192C381.766 283.312 368.384 296.518 359.261 308.631C351.789 318.553 344.214 327.24 341.35 332.796C346.588 331.137 366.564 327.616 407.801 319.96C415.481 318.535 424.717 316.724 432.301 315.382C453.352 311.555 474.12 306.307 494.462 299.672L494.462 299.672Z"
        fill="#FCF1E0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M494.462 299.672C498.873 305.293 490.58 310.94 481.606 318.649C472.632 326.357 452.11 341.207 414.07 352.868C374.702 364.937 366.113 364.937 350.307 367.519C353.623 376.808 358.103 387.259 359.596 389.079C361.088 390.899 381.989 395.379 390.447 397.704C398.906 400.029 418.148 404.004 421.134 403.345C424.12 402.685 452.669 372.589 467.088 352.865C477.937 338.179 487.846 322.821 496.755 306.883C497.439 305.628 497.581 304.149 497.148 302.788C496.715 301.426 495.745 300.301 494.462 299.672Z"
        fill="#F5DFCE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M483.692 300.373C483.692 300.373 454.24 298.641 432.267 294.862C412.223 291.415 384.947 285.762 379.627 286.487C373.921 291.577 368.613 297.096 363.75 302.996C365.808 301.654 375.433 301.441 402.95 303.006C426.075 304.32 470.602 303.947 483.692 300.373Z"
        fill="#FFF8ED"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M493.84 312.148C480.61 333.988 437.803 376.14 390.445 397.707C398.905 400.029 418.146 404.007 421.132 403.347C424.118 402.688 452.667 372.592 467.085 352.867C479.52 335.857 489.205 320.14 493.839 312.148H493.84Z"
        fill="#EDC1AD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M491.791 298.85C486.137 297.933 462.034 294.857 441.025 291.697C441.025 291.697 426.736 304.419 434.656 327.236C442.576 350.053 467.084 352.869 467.084 352.869C477.935 338.183 487.845 322.825 496.755 306.887C497.916 304.399 497.929 299.847 491.791 298.85Z"
        fill="#194A72"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M490.967 298.722L490.44 298.643L490.144 298.598L489.617 298.52L489.197 298.46L488.678 298.384L488.203 298.317L487.628 298.236L487.132 298.166L486.449 298.071L486.002 298.008L485.162 297.891L484.758 297.837C474.662 296.437 456.96 294.095 441.029 291.699C434.905 298.006 431.736 306.61 432.306 315.382C465.669 309.471 498.205 301.429 491.796 298.85L491.178 298.754L490.967 298.722Z"
        fill="#29688C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M496.995 306.277C497.032 306.172 497.067 306.066 497.097 305.956C497.117 305.888 497.135 305.816 497.152 305.751C497.177 305.651 497.198 305.552 497.221 305.451C497.237 305.373 497.253 305.291 497.267 305.212C497.281 305.132 497.292 305.025 497.304 304.932C497.317 304.838 497.327 304.754 497.334 304.663C497.334 304.593 497.334 304.523 497.342 304.45C497.352 304.227 497.348 304.003 497.331 303.781C497.331 303.732 497.331 303.681 497.32 303.632C497.306 303.505 497.286 303.379 497.264 303.253C497.254 303.201 497.245 303.149 497.236 303.098C497.208 302.967 497.175 302.839 497.136 302.71C497.123 302.666 497.111 302.627 497.097 302.585C497.051 302.445 497.002 302.305 496.943 302.172L496.929 302.14C496.71 301.647 496.406 301.196 496.032 300.807L496.02 300.795C495.896 300.667 495.764 300.546 495.627 300.432L495.539 300.359C495.397 300.245 495.249 300.138 495.096 300.039C495.06 300.015 495.022 299.992 494.987 299.97C494.82 299.866 494.648 299.764 494.461 299.672C498.872 305.293 490.579 310.94 481.604 318.649C475.813 323.624 461.988 331.834 444.157 341.934C453.957 351.003 467.102 353.367 467.084 352.869C477.934 338.183 487.844 322.825 496.754 306.888C496.821 306.747 496.883 306.593 496.94 306.438C496.962 306.386 496.977 306.325 496.995 306.277Z"
        fill="#123668"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M433.849 303.7C454.108 303.637 475.324 302.661 483.689 300.376C483.689 300.376 458.787 298.91 437.694 295.736C436.045 298.197 434.751 300.878 433.849 303.7Z"
        fill="#3C8DAA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M469.645 349.328C470.287 348.434 470.92 347.544 471.545 346.658L471.631 346.539C472.284 345.617 472.925 344.702 473.553 343.794L474.03 343.105C474.608 342.273 475.178 341.447 475.74 340.627C475.789 340.554 475.84 340.48 475.889 340.407C476.493 339.524 477.086 338.65 477.667 337.787C477.816 337.566 477.963 337.348 478.11 337.13C478.627 336.36 479.136 335.599 479.637 334.847L479.837 334.547C480.397 333.707 480.942 332.881 481.47 332.069L481.849 331.488C482.322 330.763 482.787 330.048 483.242 329.345C483.305 329.247 483.369 329.147 483.433 329.052C483.941 328.263 484.437 327.49 484.919 326.732L485.236 326.235C485.661 325.568 486.077 324.911 486.483 324.266L486.661 323.985C487.121 323.252 487.567 322.537 487.999 321.842C488.073 321.726 488.139 321.61 488.215 321.495C488.606 320.862 488.987 320.245 489.357 319.643C489.399 319.573 489.444 319.503 489.488 319.431C489.896 318.764 490.288 318.118 490.667 317.494L490.791 317.288C491.152 316.69 491.501 316.11 491.833 315.556L491.883 315.473C492.238 314.877 492.576 314.307 492.898 313.763L492.936 313.698C493.255 313.156 493.557 312.638 493.84 312.158C487.787 322.15 475.53 336.396 459.491 350.975C461.955 351.853 464.499 352.49 467.086 352.877C467.781 351.928 468.465 350.984 469.139 350.044L469.645 349.328Z"
        fill="#0E2D54"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M145.564 319.961C144.876 325.021 147.169 333.563 159.843 338.192C172.518 342.82 190.923 339.098 192.91 339.098C194.897 339.098 197.097 340.419 195.775 347.692C194.452 354.965 196.659 364.937 196.659 364.937C194.482 366.376 193.724 369.215 194.894 371.548C196.657 376.116 193.131 380.508 193.131 385.362C193.131 390.216 190.267 403.633 202.606 404.962C214.946 406.291 245.575 393.236 245.134 389.411C244.693 385.586 235.793 383.303 230.878 376.07C225.963 368.838 227.607 324.349 208.72 323.667C189.833 322.985 145.564 319.961 145.564 319.961Z"
        fill="url(#paint0_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M156.658 204.059C156.658 204.059 146.033 200.785 136.829 210.429C129.374 218.238 123.21 230.355 129.338 235.105C135.466 239.855 156.658 204.059 156.658 204.059Z"
        fill="#28BBE2"
      />
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M156.659 204.061C149.455 207.159 143.148 212.022 138.318 218.201C132.605 225.317 129.153 225.433 129.07 221.421C126.395 226.946 125.72 232.307 129.332 235.107C135.467 239.852 156.659 204.061 156.659 204.061Z"
          fill="#242357"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M121.882 248.916C118.882 248.464 112.744 250.053 109.398 257.721C106.052 265.389 103.633 283.425 108.467 289.749C113.301 296.072 119.458 294.447 119.458 294.447L121.882 248.916Z"
        fill="#28BBE2"
      />
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M112.626 271.739C111.366 280.385 106.94 280.419 105.756 278.026C105.783 282.856 106.545 287.231 108.469 289.747C113.303 296.069 119.46 294.445 119.46 294.445L121.884 248.916C121.884 248.916 115.07 255 112.626 271.739Z"
          fill="#242357"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M199.815 202.085C194.011 198.813 175.595 196.065 161.283 201.626C146.971 207.187 125.766 235.575 117.767 259.065C109.767 282.556 116.536 303.882 142.163 306.858C167.79 309.835 181.019 306.298 187.243 303.325C193.467 300.351 203.385 278.899 207.778 254.958C212.171 231.016 199.815 202.085 199.815 202.085Z"
        fill="#28BBE2"
      />
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M199.814 202.086C198.16 201.154 186.318 199.736 174.18 203.527C162.987 207.027 144.36 220.548 134.343 239.329C124.327 258.11 135.298 294.992 134.343 297.674C133.593 299.774 125.7 299.084 119.312 294.217C123.692 300.937 131.195 305.585 142.161 306.859C167.789 309.834 181.017 306.299 187.241 303.326C193.465 300.352 203.383 278.9 207.776 254.959C212.169 231.017 199.814 202.086 199.814 202.086Z"
          fill="#242357"
        />
      </g>
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M116.396 250.904C113.11 252.79 109.584 257.565 108.301 264.051C107.019 270.538 109.998 269.556 110.876 266.629C111.754 263.701 112.952 256.977 116.278 253.215C118.987 250.148 117.713 250.149 116.396 250.904Z"
        fill="#F5FFFE"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M146.701 205.169C142.083 206.625 138.12 209.652 135.501 213.724C133.516 217.272 135.7 218.153 137.881 215.775C140.062 213.398 144.31 208.004 148.58 206.416C152.85 204.829 150.477 204.06 146.701 205.169Z"
        fill="#F5FFFE"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M175.441 199.839C176.498 199.979 172.697 201.033 166.913 204.06C160.728 207.297 151.642 214.752 147.873 218.388C144.105 222.023 141.755 218.731 151.672 209.542C159.219 202.544 170.392 199.199 175.441 199.839Z"
        fill="#F5FFFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M234.697 226.064C236.15 228.822 241.762 246.496 236.727 256.178C231.693 265.861 226.254 259.539 226.254 259.539L231.154 227.119L234.697 226.064Z"
        fill="#007CB6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M234.361 232.459C234.185 230.441 233.793 228.447 233.192 226.512L231.154 227.117L226.254 259.536C227.194 260.563 228.442 261.258 229.81 261.517C229.344 260.652 229.03 260.172 229.03 260.172C229.03 260.172 236.055 249.529 234.361 232.459Z"
        fill="#00629E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M237.671 253.915C234.826 251.994 231.099 251.994 228.254 253.915C225.546 256.026 224.781 263.037 224.781 263.037L227.394 279.707C228.879 280.925 230.638 281.766 232.519 282.156C234.476 282.271 236.377 281.477 237.671 280.004C238.765 279.081 241.223 279.081 242.144 276.623C243.065 274.164 243.067 271.244 244.296 269.553C245.525 267.862 249.336 265.097 247.656 260.639C245.976 256.181 245.263 254.094 246.266 250.649C247.153 247.601 248.619 244.994 246.995 243.019C244.976 240.56 240.794 242.503 238.778 245.73C238.852 248.5 238.478 251.264 237.671 253.915Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M239.201 264.453C239.17 263.395 235.097 262.229 232.24 259.391C229.382 256.553 232.24 251.793 235.64 252.922C233.161 252.042 230.41 252.41 228.25 253.911C225.541 256.023 224.776 263.034 224.776 263.034L227.389 279.704C228.874 280.922 230.633 281.762 232.514 282.152C233.807 282.312 235.113 281.974 236.167 281.207C235.095 281.655 233.857 281.342 233.127 280.439C231.727 278.873 233.62 275.548 234.559 273.377C235.499 271.206 230.219 269.517 232.88 264.837C234.184 262.534 239.236 265.515 239.201 264.453Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M244.401 241.92C242.044 242.267 239.974 243.67 238.779 245.731C238.852 248.501 238.478 251.265 237.67 253.917C237.67 253.917 240.539 255.769 242.595 257.208C241.842 256.079 241.312 254.815 241.034 253.487C240.159 250.709 240.231 247.719 241.237 244.986C241.864 243.599 242.996 242.503 244.401 241.92V241.92Z"
        fill="#F2A37C"
      />
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M245.28 249.832C243.934 252.827 245.111 256.712 246.244 259.475C247.376 262.239 247.544 264.815 244.695 269.058C246.178 267.339 249.175 264.688 247.659 260.636C245.987 256.18 245.265 254.091 246.267 250.646C247.155 247.598 248.621 244.991 246.997 243.016C247.543 244.001 246.846 246.349 245.28 249.832Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M222.095 218.374C222.095 218.374 230.246 216.566 231.719 231.424C233.414 248.493 226.387 259.137 226.387 259.137C226.387 259.137 234.562 271.558 230.253 286.37C227.421 296.102 179.314 305.522 142.159 297.345C142.159 297.345 143.405 264.102 155.319 241.345C162.328 227.835 173.528 216.961 187.239 210.353L199.818 209.541C199.818 209.541 205.63 216.992 211.14 219.302C216.651 221.612 222.095 218.374 222.095 218.374Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M182.411 299.993L199.428 286.371C199.428 286.371 178.968 290.794 167.149 288.509C155.33 286.224 152.53 274.32 156.658 269.059L153.578 262.049L147.401 262.798C144.558 274.12 142.804 285.688 142.162 297.344C155.388 300.106 168.937 300.998 182.411 299.993Z"
        fill="#CCE4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M208.716 253.738C208.716 253.738 221.545 254.158 226.389 259.138C227.096 258.14 227.664 257.051 228.079 255.901C222.388 252.001 215.128 251.19 208.716 253.738Z"
        fill="#CCE4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M159.707 265.776C164.964 267.102 171.873 273.942 185.803 274.855C199.733 275.768 206.073 271.474 212.56 265.776C204.695 268.872 195.988 269.08 187.984 266.362C172.842 261.14 168.524 248.203 153.009 247.852C152.763 247.852 152.528 247.864 152.287 247.87C146.985 260.732 144.424 275.391 143.212 285.39L159.707 265.776Z"
        fill="#CCE4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M214.74 235.541C214.74 235.541 214.481 246.718 205.5 249.832C205.5 249.832 218.78 249.692 219.164 241.907C219.548 234.121 214.74 235.541 214.74 235.541Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M208.716 223.59C208.716 223.59 209.091 234.671 215.765 236.495C222.674 238.382 217.043 223.762 216.106 223.642C215.17 223.521 208.716 223.59 208.716 223.59Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M214.37 221.4C210.905 222.94 209.28 227.066 208.992 229.807C208.703 232.548 208.731 233.085 208.048 232.935C205.656 232.599 203.435 231.503 201.714 229.807C198.546 226.96 206.045 215.779 206.045 215.779H207.426C210.117 215.78 212.556 217.359 213.658 219.813L214.37 221.4Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M225.605 224.474C227.469 226.584 227.327 231.029 227.469 231.956C227.61 232.883 232.183 229.66 232.519 227.917C232.855 226.174 230.156 218.615 230.156 218.615L225.605 224.474Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M189.479 212.318L198.364 211.744C201.203 219.005 201.203 227.068 198.364 234.329C193.64 246.851 184.201 252.787 173.494 251.658L189.479 212.318Z"
        fill="#CCE4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.234 210.355L196.119 209.781C198.957 217.041 198.957 225.104 196.119 232.365C191.394 244.888 181.955 250.822 171.249 249.695L187.234 210.355Z"
        fill="#007CB6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M171.251 249.695C172.886 249.865 174.534 249.862 176.168 249.687C181.077 244.041 186.916 236.957 189.71 232.171C193.396 225.838 193.973 218.164 191.275 211.351C190.958 210.882 190.552 210.481 190.078 210.172L187.236 210.355L171.251 249.695Z"
        fill="#00629E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M169.575 245.692C169.575 245.692 125.863 299.988 122.603 303.738C119.342 307.487 118.691 311.236 111.191 311.074C103.691 310.911 98.1502 312.377 91.9552 313.844C85.7601 315.311 81.36 314.824 81.8472 311.235C82.3344 307.645 89.5094 303.084 89.5094 303.084L74.1865 297.541C75.9521 295.284 78.6557 293.962 81.5211 293.954C86.5738 293.791 94.8883 296.074 97.3342 296.074C99.7801 296.074 102.062 294.443 106.627 288.248C111.193 282.053 146.076 235.105 146.076 235.105L169.575 245.692Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M141.085 241.824C138.251 245.639 134.478 250.718 130.445 256.146C133.683 259.981 137.009 263.202 138.425 263.556C140.263 264.016 145.118 262.729 147.4 262.798C147.4 262.798 119.744 299.562 116.221 303.613C112.697 307.665 106.041 306.233 99.9498 307.983C93.8585 309.733 86.3236 315.34 82.0508 312.883C83.0153 314.932 86.8823 315.047 91.9557 313.846C98.1492 312.377 103.693 310.906 111.192 311.075C118.69 311.245 119.344 307.488 122.603 303.739C125.071 300.903 150.701 269.121 163.024 253.826L141.085 241.824Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.7715 300.793C93.7715 300.793 78.7118 297.164 77.414 296.673C76.2799 296.244 77.3678 294.872 78.2246 294.594C76.6217 295.167 75.219 296.191 74.1855 297.544L89.5085 303.086C90.8892 302.249 92.3121 301.484 93.7717 300.793H93.7715Z"
        fill="#F2A37C"
      />
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.627 288.252C102.062 294.447 99.7798 296.078 97.3341 296.078C94.8884 296.078 86.575 293.794 81.521 293.958C81.1433 293.972 80.7667 294.005 80.3926 294.059C85.6383 294.132 91.4834 296.355 94.3842 297.108C97.285 297.861 99.9842 298.508 103.392 294.595C106.799 290.682 129.691 257.167 129.698 257.156C119.959 270.267 109.044 284.967 106.627 288.252Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.229 210.357C184.495 206.017 171.158 206.276 160.465 215.397C148.305 225.768 136.823 237.629 136.823 237.629C136.823 237.629 138.41 243.425 147.332 251.276C151.876 255.462 157.843 257.761 164.021 257.706C164.021 257.706 180.349 240.279 185.664 231.182C189.351 224.847 189.928 217.171 187.229 210.357Z"
        fill="#DEF1F8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M147.338 251.273C151.882 255.459 157.848 257.758 164.026 257.703C164.026 257.703 180.353 240.276 185.669 231.177C187.493 228.078 188.577 224.6 188.835 221.013L188.82 220.938C184.466 230.971 163.62 254.148 136.828 237.625C136.828 237.625 138.414 243.421 147.338 251.273Z"
        fill="#CCE4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M182.429 209.613C175.761 209.272 169.172 211.179 163.716 215.027C158.626 218.636 154.842 222.833 163.716 223.406C172.591 223.979 181.446 217.452 183.682 215.027C185.804 212.731 187.154 210.007 182.429 209.613Z"
        fill="#E9F6FB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.422 210.803C173.087 211.394 169.276 213.134 167.156 215.318C165.037 217.502 177.362 215.94 181.2 214.295C185.922 212.272 184.343 210.147 178.422 210.803Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M226.829 210.443C226.829 210.443 231.483 210.108 233.656 213.086C235.512 215.631 236.512 220.314 234.696 226.067C232.708 232.367 229.956 232.459 229.376 232.344C228.796 232.23 229.44 225.905 227.217 223.648C224.994 221.391 222.092 218.375 222.092 218.375C222.092 218.375 224.28 211.826 226.829 210.443Z"
        fill="#DEF1F8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M234.559 214.711C234.314 214.139 234.01 213.594 233.653 213.084C231.48 210.106 226.827 210.441 226.827 210.441C224.277 211.824 222.092 218.373 222.092 218.373C222.092 218.373 224.995 221.393 227.217 223.646C228.417 224.864 228.781 227.266 228.953 229.237C229.435 225.204 228.533 222.474 227.465 218.701C226.955 216.845 227.851 214.892 229.59 214.067C231.251 213.446 233.111 213.687 234.558 214.711H234.559Z"
        fill="#CCE4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M232.842 216.413C230.858 215.24 230.024 218.47 230.721 222.013C231.104 224.713 231.066 227.456 230.609 230.144C230.548 231.124 232.337 229.778 233.614 226.084C234.89 222.391 235.253 217.838 232.842 216.413Z"
        fill="#E9F6FB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M208.699 200.105C206.007 203.495 203.036 206.652 199.814 209.543C199.814 209.543 205.206 221.433 216.109 223.645C216.109 223.645 223.747 218.682 226.889 211.013C226.889 211.013 225.574 206.54 218.464 202.59C211.353 198.641 208.699 200.105 208.699 200.105Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M218.456 202.59C211.347 198.641 208.697 200.105 208.697 200.105C208.697 200.105 208.277 200.681 207.317 201.806L206.712 202.506C206.712 202.506 208.378 207.966 215.498 211.98C218.307 213.6 221.388 214.691 224.59 215.2C225.495 213.888 226.263 212.487 226.883 211.018C226.883 211.018 225.566 206.54 218.456 202.59Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M218.457 202.59C211.348 198.641 208.698 200.105 208.698 200.105C208.698 200.105 208.438 200.455 207.921 201.085C213.609 207.342 221.032 209.485 226.882 211.013C226.882 211.013 225.568 206.54 218.457 202.59Z"
        fill="#DD8964"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M215.764 236.499C215.584 239.484 214.644 247.619 205.366 248.377C196.089 249.134 189.661 248.083 175.471 236.499C161.28 224.916 153.901 219.208 140.845 221.399C136.492 222.456 121.733 235.887 121.546 239.295C121.358 242.703 138.196 258.026 139.898 259.351C141.601 260.677 151.469 258.115 161.721 262.419C170.618 266.153 179.081 274.866 198.655 271.839C218.228 268.813 227.085 248.459 224.266 236.501C224.268 236.499 221.811 233.506 215.764 236.499Z"
        fill="#EA4D5F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M167.149 229.877C164.472 227.789 161.635 225.917 158.662 224.277C149.868 234.003 139.159 241.806 127.207 247.198C130.822 251.058 135.293 255.258 137.892 257.6C151.61 249.771 163.111 236.168 167.149 229.877Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M180.209 271.021C184.104 272.103 188.142 272.58 192.182 272.435C194.406 264.331 194.938 255.856 193.744 247.537C191.633 246.899 189.595 246.043 187.661 244.982C187.222 254.121 184.671 263.034 180.209 271.021Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M207.412 269.056C210.063 267.725 212.501 266.006 214.644 263.955C213.361 258.208 210.9 252.79 207.415 248.043C206.742 248.205 206.058 248.316 205.369 248.375C203.853 248.498 202.417 248.565 201.007 248.554C205.333 254.5 207.583 261.704 207.412 269.056Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M168.256 265.757C175.352 257.044 178.932 246.614 180.559 240.44C178.974 239.283 177.288 237.98 175.473 236.497C174.854 235.991 174.262 235.517 173.668 235.027C168.975 246.817 160.626 255.747 155.38 260.523C157.554 260.933 159.68 261.568 161.723 262.416C163.958 263.414 166.138 264.53 168.256 265.757H168.256Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M215.087 240.594C214.567 242.491 213.552 244.216 212.146 245.592C215.999 247.482 219.336 250.276 221.873 253.737C222.834 251.638 223.573 249.444 224.077 247.191C221.545 244.42 218.489 242.178 215.087 240.594Z"
        fill="#EFF8FC"
      />
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M215.767 236.498C215.709 239.575 214.655 242.551 212.761 244.978V244.978C214.731 243.173 216.134 240.833 216.798 238.245C216.798 238.245 222.655 240.11 224.269 236.494L219.969 235.207C218.501 235.373 217.075 235.811 215.767 236.498Z"
          fill="#242357"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M215.749 219.01C217.576 218.247 222.645 217.33 225.078 219.869C227.511 222.409 228.071 225.446 226.829 229.907C226.258 232.204 225.397 234.419 224.267 236.499C221.641 238.034 218.391 238.034 215.764 236.499C212.149 233.279 210.08 228.669 210.077 223.827C211.486 221.728 213.449 220.061 215.749 219.01Z"
        fill="#EA4D5F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M224.818 235.442C221.271 230.654 216.099 227.323 210.271 226.076C210.478 227.522 210.857 228.938 211.403 230.293C215.343 231.893 218.884 234.34 221.774 237.46C222.657 237.297 223.503 236.97 224.266 236.496C224.266 236.496 224.484 236.137 224.818 235.442Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M217.163 218.568C216.681 218.677 216.208 218.824 215.749 219.008C214.559 219.579 213.447 220.299 212.438 221.151C218.038 222.45 223.083 225.489 226.849 229.831C227.346 228.213 227.541 226.517 227.424 224.828C224.563 221.939 221.041 219.791 217.163 218.568Z"
        fill="#EFF8FC"
      />
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M214.37 229.805C213.432 224.387 215.368 219.424 218.043 218.393C217.258 218.515 216.489 218.722 215.748 219.01C213.449 220.061 211.486 221.728 210.077 223.827C210.079 228.666 212.147 233.277 215.762 236.497C217.048 237.187 218.476 237.571 219.935 237.619C217.471 236.681 215.224 234.738 214.37 229.805Z"
          fill="#242357"
        />
      </g>
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M197.284 268.2C180.204 267.826 174.902 261.76 161.654 255.859C155.238 253.003 144.747 253.674 142.16 252.488C138.94 251.011 125.726 239.696 125.313 238.496C124.592 236.396 133.564 226.064 133.564 226.064C127.978 230.6 121.671 237.074 121.549 239.293C121.36 242.698 138.2 258.024 139.902 259.349C141.605 260.675 151.473 258.113 161.725 262.417C170.622 266.151 179.085 274.864 198.659 271.837C206.821 270.572 214.097 265.988 218.763 259.172C214.63 263.967 209.275 268.464 197.284 268.2Z"
          fill="#242357"
        />
      </g>
      <path
        opacity="0.15"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M153.557 224.006C149.864 222.883 145.978 222.534 142.143 222.983C139.92 223.386 135.927 227.099 133.523 230.058C129.361 235.18 139.694 229.764 154.204 235.812C168.714 241.86 187.391 251.652 191.114 250.449C194.836 249.247 183.967 245.276 175.434 238.409C168.338 232.678 159.63 225.854 153.557 224.006Z"
        fill="white"
      />
      <path
        opacity="0.15"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M224.268 220.437C221.783 218.806 220.742 223.196 220.992 227.914C221.243 232.632 221.789 236.334 223.144 235.754C224.499 235.175 226.706 229.335 226.543 226.08C226.381 222.825 225.51 221.254 224.268 220.437Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M206.328 202.943C204.892 201.791 203.019 201.336 201.214 201.702C197.774 202.145 187.9 209.024 187.235 210.356C186.57 211.689 186.756 217.431 193.675 225.446C197.526 229.912 204.105 232.658 205.88 233.213C207.656 233.767 206.619 223.273 215.756 219.011C215.756 219.011 216.244 217.029 211.836 215.14C208.616 213.765 204.055 209.54 203.833 205.638L206.328 202.943Z"
        fill="#DEF1F8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M203.821 205.638L206.328 202.943C204.892 201.791 203.019 201.336 201.214 201.702C197.774 202.145 187.9 209.024 187.235 210.356C186.57 211.689 186.756 217.431 193.675 225.446C189.824 219.939 190.328 211.885 193.37 209.544C196.412 207.204 200.861 203.62 202.389 207.519C203.916 211.418 210.089 214.191 210.089 214.192C207.168 212.321 204.004 208.881 203.821 205.638Z"
        fill="#CCE4EA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M210.594 217.047C212.179 216.16 215.933 217.248 213.173 219.076C209.064 221.8 206.462 228.72 205.977 230.12C205.493 231.52 202.227 230.286 199.6 228.635C196.974 226.984 194.921 225.216 194.363 223.44C194.122 222.67 199.926 226.5 203.314 223.645C206.702 220.791 207.408 218.834 210.594 217.047Z"
        fill="#E9F6FB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.689 183.521C186.219 189.918 188.64 193.809 190.282 195.451C191.925 197.093 195.297 198.13 196.42 194.586C197.698 197.444 200.223 199.553 203.263 200.301C208.365 201.512 210.078 197.871 210.078 197.871L201.866 185.252L187.689 183.521Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.69 183.521C187.294 185.17 187.161 186.871 187.294 188.561C190.383 191.406 194.913 192.033 198.658 190.134C198.658 190.134 201.011 197.869 207.999 199.892C208.876 199.437 209.6 198.733 210.079 197.869L201.867 185.249L187.69 183.521Z"
        fill="#BA422B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M243.616 134.481C254.716 134.481 268.32 142.299 271.448 154.501C274.576 166.704 273.636 176.861 275.2 183.901C276.18 188.298 276.907 193.679 274.881 198.364C274.508 199.228 274.081 200.068 273.601 200.878C270.283 206.478 264.011 210.479 255.19 212.555C245.04 214.701 234.487 213.895 224.781 210.232C212.741 205.229 204.682 199.693 199.522 186.246C193.75 170.546 199.427 152.934 213.281 143.56C228.762 133.073 243.616 134.481 243.616 134.481Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M202.056 172.72C202.291 174.854 204.24 176.875 208.014 175.482C211.788 174.089 218.83 167.6 220.194 150.414L202.056 172.72Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M243.615 134.482C238.87 134.264 234.121 134.815 229.552 136.113C225.034 138.913 220.991 141.293 220.991 141.293C226.237 152.574 237.615 159.514 244.822 161.068C252.029 162.622 260.663 162.608 263.862 158.195C266.865 154.052 262.266 149.784 262.266 149.784C264.845 151.525 267.825 152.58 270.925 152.848C267.047 141.605 254.208 134.482 243.615 134.482Z"
        fill="#F2A37C"
      />
      <circle
        opacity="0.5"
        cx="221.94"
        cy="185.33"
        r="12.2794"
        fill="#EE9681"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M263.892 185.662C263.892 192.005 268.727 197.305 275.045 197.885C276.833 193.31 276.145 188.144 275.199 183.885C274.577 180.479 274.203 177.031 274.079 173.57C268.194 174.585 263.893 179.69 263.892 185.662H263.892Z"
        fill="#EE9681"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M274.745 181.323C272.856 182.78 270.54 183.573 268.154 183.581C261.879 183.581 256.77 178.121 256.634 171.359C256.502 171.311 256.374 171.253 256.252 171.185C255.93 170.998 255.616 170.796 255.304 170.596C255.304 170.76 255.28 170.921 255.28 171.086C255.28 171.167 255.291 171.247 255.293 171.327C254.846 171.145 254.366 171.062 253.884 171.086C252.655 171.057 251.441 171.354 250.365 171.948C250.38 171.668 250.409 171.379 250.409 171.086V171.043C250.216 171.222 250.035 171.415 249.87 171.621C249.654 171.919 249.354 172.148 249.009 172.279C248.363 180.001 241.744 185.84 234.002 185.52C226.26 185.2 220.146 178.835 220.139 171.086C220.139 170.686 220.165 170.289 220.199 169.896C220.018 169.812 219.847 169.708 219.691 169.585L218.948 169.01C218.92 169.228 218.901 169.448 218.878 169.668L198.258 166.588L199.337 172.532L218.923 173.001C219.854 180.651 226.168 186.513 233.866 186.873C241.564 187.233 248.398 181.986 250.038 174.456C251.248 173.841 252.586 173.521 253.943 173.522C254.485 173.51 255.025 173.601 255.533 173.791C256.512 180.056 261.817 184.734 268.156 184.921C270.592 184.916 272.971 184.177 274.982 182.801L274.745 181.323Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M274.746 181.322C272.857 182.778 270.54 183.572 268.155 183.581C266.812 183.577 265.482 183.319 264.235 182.82C264.129 183.264 264.048 183.714 263.992 184.167C265.324 184.663 266.734 184.918 268.156 184.92C270.592 184.915 272.971 184.176 274.982 182.801L274.824 181.811C274.809 181.702 274.788 181.597 274.772 181.486L274.746 181.322Z"
        fill="#EB7C74"
      />
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M274.442 186.591C275.298 192.973 274.96 198.666 268.55 204.479C261.053 211.276 247.333 213.961 238.325 213.422C243.957 214.041 249.653 213.745 255.191 212.546C264.011 210.47 270.283 206.463 273.602 200.869C274.082 200.059 274.51 199.22 274.882 198.356C276.908 193.668 276.178 188.29 275.201 183.892C274.655 181.039 274.316 178.15 274.189 175.247L273.972 175.092C274.315 177.038 273.584 180.21 274.442 186.591Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M234.111 186.866C234.168 186.422 234.201 185.976 234.208 185.529C227.187 185.329 221.324 180.117 220.303 173.168C219.863 173.228 219.426 173.311 218.994 173.417C220.127 180.961 226.487 186.619 234.111 186.866Z"
        fill="#EB7C74"
      />
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M220.461 174.872C220.461 176.272 218.682 177.392 216.488 177.392C214.294 177.392 212.515 176.262 212.515 174.872C212.515 173.481 214.294 172.352 216.488 172.352C218.682 172.352 220.461 173.479 220.461 174.872Z"
        fill="white"
      />
      <g style="mix-blend-mode:multiply" opacity="0.7">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M233.658 182.403C239.897 182.403 246.168 177.799 247.119 168.917C248.069 160.035 241.576 151.484 230.688 154.718C219.8 157.952 219.56 170.905 222.848 175.942C225.143 179.769 229.2 182.194 233.658 182.403Z"
          fill="url(#paint1_linear)"
        />
      </g>
      <g style="mix-blend-mode:multiply" opacity="0.7">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M271.473 154.629C268.945 153.816 266.224 153.827 263.702 154.661C253.706 157.622 253.489 169.516 256.509 174.138C258.615 177.651 262.34 179.878 266.432 180.068C269.341 180.061 272.146 178.982 274.31 177.037C273.844 170.843 273.671 163.244 271.473 154.629Z"
          fill="url(#paint2_linear)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M198.257 165.359C200.286 167.339 201.618 169.921 202.057 172.721C202.469 175.61 207.086 176.76 213.321 167.968C221.94 155.818 220.992 141.293 220.992 141.293C226.638 147.258 233.272 152.202 240.602 155.907C252.019 161.409 258.758 159.937 262.06 158.541C265.361 157.146 267.699 153.156 264.672 148.204C264.672 148.204 270.311 152.605 281.177 152.192C292.042 151.779 296.444 146.553 293.417 142.565C290.39 138.576 284.58 135.454 276.172 132.917C276.172 132.917 285.853 132.114 285.304 126.75C284.755 121.387 271.063 108.291 244.924 111.91C215.553 115.97 211.124 130.985 211.124 130.985C211.124 130.985 207.083 128.63 198.258 128.699C192.026 128.748 187.924 131.246 187.511 132.654C187.098 134.062 188 134.876 190.843 135.964C193.041 136.758 195.191 137.678 197.283 138.72C192.155 140.348 187.421 143.025 183.383 146.581C176.369 152.632 176.457 158.179 177.193 158.959C178.575 160.423 182.187 156.975 187.413 156.286C187.413 156.286 183.794 164.438 184.753 171.451C185.712 178.463 198.257 165.359 198.257 165.359Z"
        fill="#E26644"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M228.363 131.367C225.003 131.947 222.612 134.737 227.222 136.385C231.832 138.033 246.423 144.159 253.307 149.738C260.606 155.656 266.362 156.808 264.564 151.114C262.01 144.398 257.165 138.8 250.885 135.31C244.043 131.475 236.1 130.085 228.363 131.367H228.363Z"
        fill="#EE7249"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M257.644 159.686C250.019 159.201 235.685 152.721 221.704 135.764C221.51 135.529 221.185 135.451 220.906 135.572C220.626 135.692 220.46 135.983 220.497 136.285C220.671 137.622 220.867 139.387 220.99 141.294C226.636 147.259 233.27 152.203 240.6 155.909C248.269 159.603 253.819 160.142 257.644 159.686Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M228.869 115.938C213.813 121.885 211.124 130.985 211.124 130.985C211.124 130.985 207.083 128.63 198.258 128.698C192.026 128.746 187.924 131.245 187.511 132.654C187.098 134.062 188 134.875 190.843 135.963C193.041 136.757 195.191 137.678 197.283 138.72C192.155 140.348 187.421 143.025 183.383 146.581C176.369 152.632 176.457 158.178 177.193 158.958C178.575 160.423 182.187 156.974 187.413 156.286C187.413 156.286 183.794 164.438 184.753 171.45C185.712 178.463 198.251 165.36 198.251 165.36C199.416 166.533 200.368 167.9 201.065 169.399C201.811 168.027 202.364 166.676 201.853 165.899C199.218 161.877 198.244 155.929 200.733 148.371C202.121 143.386 205.642 139.269 210.351 137.124C212.227 136.22 214.289 135.771 216.371 135.812C216.6 135.818 216.815 135.704 216.939 135.511C217.023 135.297 217.011 135.058 216.907 134.853C216.118 132.431 216.1 129.824 216.857 127.392C218.198 123.369 221.045 119.916 228.869 115.938Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M201.278 169.877C201.653 170.79 201.914 171.745 202.057 172.722C202.284 174.314 203.847 175.404 206.211 174.584C205.476 174.808 204.678 174.612 204.132 174.073C203.895 173.636 203.801 173.135 203.863 172.642L209.183 172.769H209.191C209.969 172.103 210.69 171.373 211.346 170.587L206.6 170.254L201.278 169.877Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M281.176 152.192C288.289 151.923 292.611 149.586 293.916 146.887C287.959 151.787 274.048 148.178 268.156 145.407C265.106 143.897 262.144 142.214 259.285 140.367C261.573 142.606 263.402 145.269 264.671 148.207C264.671 148.207 270.31 152.605 281.176 152.192Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M285.302 126.749C285.044 125.351 284.395 124.054 283.43 123.01C286.612 127.63 281.015 128.915 277.115 129.696C273.214 130.477 262.768 131.063 262.768 131.063C262.768 131.063 273.014 132.332 276.171 132.916C276.171 132.916 285.852 132.114 285.302 126.749Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M193.542 133.557C189.659 132.563 189.675 130.674 191.539 129.834C189.187 130.689 187.745 131.847 187.508 132.652C187.095 134.062 187.997 134.874 190.84 135.962C193.038 136.756 195.188 137.676 197.28 138.718C199.207 138.152 201.181 137.757 203.178 137.538C200.09 135.93 196.865 134.597 193.542 133.557Z"
        fill="#BA422B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M181.973 154.617C178.753 156.193 176.89 157.071 177.15 155.52C176.709 156.625 176.724 157.861 177.194 158.955C178.576 160.42 182.188 156.972 187.414 156.283C188.156 154.324 189.197 152.493 190.501 150.854C187.59 151.947 184.743 153.203 181.973 154.617H181.973Z"
        fill="#BA422B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M265.078 114.284C254.566 111.293 232.667 112.982 223.442 121.515C220.429 124.301 228.419 122.524 238.522 122.673C248.023 122.978 257.481 124.097 266.791 126.016C276.919 128.256 283.629 127.64 282.923 125.05C282.218 122.46 275.284 117.182 265.078 114.284Z"
        fill="#EE7249"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M293.201 145.815C294.052 143.668 289.598 139.018 282.974 136.45C276.349 133.882 266.791 132.11 264.657 132.918C262.288 133.819 269.548 143.757 280.276 146.951C289.579 149.721 292.477 147.629 293.201 145.815Z"
        fill="#EE7249"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M218.413 141.054C217.013 139.156 211.769 141.27 208.605 146.687C204.563 153.605 206.085 164.366 208.916 165.358C211.747 166.351 215.789 159.662 217.257 154.018C218.726 148.375 219.641 142.72 218.413 141.054Z"
        fill="#EE7249"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M192.615 130.47C191.184 130.913 192.234 132.6 194.695 132.647C197.18 132.694 206.642 132.162 206.517 131.275C206.392 130.387 198.844 128.533 192.615 130.47Z"
        fill="#E26644"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.75 154.617C179.111 155.054 181.073 154.369 182.905 152.57C184.738 150.771 190.052 144.67 190.503 143.89C190.954 143.111 186.75 144.56 182.905 148.207C179.061 151.854 178.364 154.151 178.75 154.617Z"
        fill="#E26644"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M273.947 134.84C277.911 135.82 287.141 137.591 292.459 144.133C290.068 142.07 287.366 140.399 284.452 139.181C281.031 137.545 277.525 136.096 273.947 134.84H273.947Z"
        fill="#F49A6E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M236.094 115.936C240.736 114.079 258.526 113.107 267.067 115.936C277.161 119.278 280.507 123.594 280.507 123.594C274.894 120.888 268.921 119.002 262.771 117.994C265.881 118.12 268.974 118.526 272.011 119.208C272.011 119.208 266.271 115.568 254.81 115.008C248.557 114.607 242.277 114.919 236.094 115.936H236.094Z"
        fill="#F49A6E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M249.523 135.514C255.035 137.625 261.887 145.027 263.606 150.125C261.794 147.197 259.658 144.483 257.237 142.034C254.834 139.669 252.255 137.49 249.523 135.514V135.514Z"
        fill="#F49A6E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M217.918 143.373C217.991 146.044 216.888 156.995 211.121 163.901C210.5 161.306 210.5 158.602 211.121 156.007C211.214 157.658 211.435 159.299 211.781 160.917C211.781 160.916 215.825 155.864 217.918 143.373Z"
        fill="#F49A6E"
      />
      <g style="mix-blend-mode:multiply" opacity="0.5">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M238.446 153.198C238.264 151.493 234.648 149.852 229.494 152.746C224.341 155.64 222.531 160.166 222.893 161.517C223.256 162.868 227.933 160.901 231.212 159.619C236.728 157.457 238.986 158.262 238.446 153.198Z"
          fill="#F2A37C"
        />
      </g>
      <g style="mix-blend-mode:multiply" opacity="0.5">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M273.01 162.418C272.78 160.838 272.498 159.214 272.148 157.546C270.985 155.902 269.455 154.551 267.68 153.6C262.525 150.704 260.593 153.21 260.571 154.927C260.52 158.806 263.931 159.354 267.151 160.46C269.826 161.377 272.045 162.648 273.01 162.418Z"
          fill="#F2A37C"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M239.066 151.165C238.832 149.073 234.646 147.991 229.491 150.885C224.337 153.778 222.528 158.305 222.89 159.657C223.253 161.009 227.93 159.04 231.209 157.757C236.728 155.597 239.552 155.516 239.066 151.165Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M233.166 154.617C228.406 156.166 225.746 156.805 225.968 155.071C226.189 153.336 228.752 151.275 229.491 150.885C224.337 153.78 222.528 158.305 222.89 159.657C223.253 161.01 227.93 159.04 231.209 157.757C236.728 155.597 239.552 155.517 239.066 151.165C238.821 152.268 237.929 153.069 233.166 154.617Z"
        fill="#BA422B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M260.579 153.063C260.6 151.346 262.539 148.842 267.688 151.736C272.837 154.629 273.868 158.757 273.505 160.113C273.143 161.47 270.485 159.737 267.157 158.596C263.926 157.491 260.521 156.944 260.579 153.063Z"
        fill="#D65132"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M271.523 158.572C270.084 157.703 266.126 156.192 263.707 154.662C261.316 153.147 262.016 150.829 263.927 150.435C263.123 150.275 262.289 150.473 261.643 150.978C260.998 151.484 260.605 152.245 260.567 153.064C260.516 156.944 263.927 157.493 267.147 158.597C270.474 159.738 273.132 161.47 273.494 160.115C273.626 159.174 273.475 158.215 273.06 157.36C273.479 158.236 272.96 159.44 271.523 158.572Z"
        fill="#BA422B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M268.155 183.693C261.056 183.693 255.275 177.485 255.275 169.855C255.275 162.225 261.05 156.018 268.155 156.018C275.26 156.018 281.035 162.225 281.035 169.855C281.035 177.485 275.255 183.693 268.155 183.693ZM268.156 157.359C261.797 157.359 256.621 162.959 256.621 169.855C256.621 176.752 261.801 182.352 268.156 182.352C274.51 182.352 279.69 176.752 279.69 169.855C279.69 162.959 274.516 157.359 268.156 157.359Z"
        fill="#19313A"
      />
      <ellipse
        cx="233.658"
        cy="172.44"
        rx="9.96746"
        ry="9.96744"
        fill="white"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M229.601 178.475C226.055 174.703 225.54 168.999 228.352 164.652L227.999 164.232C224.534 166.627 222.948 170.942 224.04 175.011C225.132 179.08 228.665 182.022 232.864 182.359C237.063 182.697 241.021 180.357 242.748 176.515C239.927 180.257 232.63 181.224 229.601 178.475Z"
        fill="#BAC4CA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M223.827 174.074C223.827 174.074 224.149 167.012 229.826 164.686C236.218 162.066 241.726 165.498 242.858 168.632C242.971 167.743 242.746 166.843 242.227 166.112C240.586 163.592 236.547 160.486 230.155 162.621C225.248 164.041 222.417 169.165 223.827 174.074Z"
        fill="#19313A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M243.623 172.439C243.625 171.467 243.483 170.5 243.203 169.57C242.754 168.045 241.572 166.847 240.053 166.378C238.139 165.754 236.037 166.179 234.515 167.498C231.555 170.335 230.874 174.809 232.857 178.397C233.57 179.426 234.574 180.217 235.74 180.671C237.454 181.268 239.36 180.829 240.64 179.541C242.551 177.673 243.627 175.112 243.623 172.439Z"
        fill="#19313A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M234.558 180.047C234.925 180.3 235.321 180.51 235.736 180.673C237.451 181.27 239.356 180.831 240.636 179.543C241.517 178.675 242.229 177.651 242.736 176.523C240.664 178.847 237.67 180.137 234.558 180.047Z"
        fill="#002030"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M241.697 167.969C241.057 167.314 240.096 167.089 239.233 167.393C238.369 167.696 237.76 168.473 237.67 169.383C237.295 172.003 239.077 174.874 241.247 174.874C242.681 174.874 243.347 173.511 243.151 171.468C243.11 170.163 242.592 168.919 241.697 167.969Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M256.434 171.491C256.384 171.075 256.179 170.693 255.86 170.42C255.292 169.999 254.59 169.8 253.885 169.86C252.58 169.821 251.292 170.155 250.171 170.823C249.696 171.106 249.374 171.589 249.296 172.136L249.051 173.833C250.479 172.817 252.191 172.278 253.944 172.293C256.264 172.293 256.755 173.571 256.755 173.571L256.434 171.491Z"
        fill="#19313A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M253.885 169.855C252.58 169.815 251.291 170.149 250.171 170.818C249.696 171.101 249.374 171.584 249.296 172.131L249.051 173.828C250.479 172.812 252.191 172.273 253.944 172.288C256.264 172.288 256.755 173.566 256.755 173.566C255.929 171.014 252.127 171.932 251.976 171.301C251.824 170.67 252.442 169.978 253.885 169.855Z"
        fill="#002030"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M219.841 168.579L198.257 165.359L199.336 171.304L219.466 171.785C219.466 171.785 219.78 169.883 219.841 168.579Z"
        fill="#19313A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M219.574 171.083L203.124 168.858C202.927 167.79 202.497 166.778 201.864 165.896L198.262 165.359L199.341 171.304L219.47 171.785C219.47 171.785 219.514 171.503 219.574 171.083Z"
        fill="#002030"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M252.272 175.663C251.203 176.168 250.194 179.663 251.107 182.663C251.757 184.976 253.863 186.576 256.266 186.583C258.721 186.667 260.057 185.239 259.994 183.434C259.941 181.857 258.047 181.827 256.266 179.654C254.617 177.654 254.268 174.718 252.272 175.663Z"
        fill="#EE9681"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M255.613 184.989C252.441 184.404 250.788 180.673 250.909 178.477C250.65 179.867 250.718 181.299 251.107 182.66C251.757 184.973 253.863 186.573 256.266 186.58C258.721 186.662 260.057 185.236 259.994 183.431C259.578 184.667 258.237 185.474 255.613 184.989Z"
        fill="#EB7C74"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M258.63 183.369C258.565 183.367 258.5 183.361 258.436 183.349C258.238 183.314 258.048 183.243 257.876 183.139C257.406 182.855 257.053 182.413 256.88 181.892C256.809 181.693 256.618 181.065 257.05 181.172C257.14 181.202 257.222 181.249 257.292 181.312C257.495 181.475 257.712 181.62 257.909 181.774C258.275 182.054 258.737 182.213 259.081 182.498C259.209 182.595 259.285 182.745 259.288 182.906C259.268 183.09 259.146 183.247 258.973 183.312C258.864 183.356 258.748 183.375 258.63 183.369Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M234.602 185.662C225.872 185.662 218.795 178.584 218.795 169.854C218.795 161.124 225.872 154.047 234.602 154.047C243.333 154.047 250.41 161.124 250.41 169.854C250.402 178.583 243.328 185.656 234.6 185.662H234.602ZM234.603 155.387C228.751 155.386 223.475 158.911 221.236 164.317C218.996 169.723 220.233 175.946 224.371 180.084C228.509 184.222 234.732 185.46 240.138 183.221C245.544 180.982 249.069 175.706 249.069 169.854C249.06 161.867 242.588 155.395 234.602 155.387H234.603Z"
        fill="#19313A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M247.94 195.293C243.993 194.75 240.188 193.456 236.728 191.481C233.405 189.725 230.863 189.471 230.274 192.041C229.422 195.75 233.058 205.201 245.254 207.034C253.061 208.207 258.731 205.93 261.888 203.37C263.488 202.126 264.687 200.438 265.333 198.517C266.033 196.277 265.154 193.599 259.653 194.662C255.804 195.47 251.854 195.683 247.94 195.293Z"
        fill="#C9434D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M246.259 195.062C242.925 194.34 239.713 193.134 236.728 191.481C233.405 189.725 230.862 189.471 230.274 192.041C229.584 195.045 231.842 201.819 239.215 205.257C243.443 203.738 246.265 199.729 246.268 195.236C246.268 195.174 246.259 195.12 246.259 195.062Z"
        fill="#7C1423"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M257.646 195.012C254.436 195.52 251.175 195.614 247.942 195.292C244.345 194.822 240.865 193.693 237.676 191.963H237.676C237.747 193.316 238.084 194.641 238.666 195.865C239.595 197.238 244.046 198.945 246.556 199.302C251.456 200.002 255.308 198.751 255.733 198.278C256.457 197.242 257.096 196.15 257.646 195.012Z"
        fill="white"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M244.775 195.741C248.874 196.714 253.142 196.729 257.248 195.785C257.482 195.34 257.646 195.012 257.646 195.012C254.436 195.52 251.175 195.614 247.942 195.292C244.345 194.822 240.865 193.693 237.676 191.963H237.676C237.747 193.316 238.084 194.641 238.666 195.865C239.307 196.812 241.627 197.917 243.826 198.63C242.056 198.006 240.614 196.693 239.828 194.99C239.612 193.972 240.847 194.731 244.775 195.741Z"
        fill="#BAC4CA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M253.019 207.074C251.964 204.793 245.715 198.954 233.139 200.547C236.203 204.18 240.544 206.499 245.267 207.028C247.834 207.433 250.447 207.449 253.019 207.074Z"
        fill="#EC6469"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M251.243 207.274C251.232 207.274 244.17 206.839 240.787 204.586C237.427 202.346 238.219 200.329 241.153 200.546C238.492 200.188 235.794 200.188 233.133 200.546C236.197 204.179 240.538 206.498 245.261 207.027C247.239 207.333 249.246 207.416 251.243 207.274Z"
        fill="#DB545B"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M247.272 202.966C245.426 201.932 243.365 201.344 241.251 201.248C238.333 201.543 244.179 203.888 246.721 204.812C249.98 205.998 250.361 204.569 247.272 202.966Z"
        fill="white"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M251.076 205.487C250.582 205.153 249.923 205.169 249.923 205.572C249.923 205.872 250.304 206.37 251.076 206.609C251.849 206.849 251.873 206.022 251.076 205.487Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M272.673 177.25C274.847 174.87 274.687 166.791 271.618 164.407C267.898 161.557 262.587 162.171 259.615 165.795C256.643 169.419 257.081 174.747 260.604 177.838C264.127 180.929 269.466 180.669 272.673 177.25Z"
        fill="white"
      />
      <path
        opacity="0.2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M272.671 177.252C273.377 176.324 273.818 175.222 273.946 174.064C272.125 177.593 267.785 179.602 263.99 177.078C259.29 173.949 259.895 166.701 261.791 163.918C258.925 165.693 257.346 168.966 257.741 172.314C258.135 175.662 260.433 178.478 263.633 179.537C266.833 180.597 270.357 179.708 272.671 177.257V177.252Z"
        fill="#BAC4CA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M257.847 173.117C257.847 173.117 257.587 166.604 262.823 164.458C265.637 163.209 268.869 163.325 271.585 164.773C272.262 165.166 272.802 165.757 273.134 166.467C273.062 165.246 272.463 164.118 271.493 163.374C269.666 162.005 266.981 161.224 263.127 162.547C255.394 165.211 257.847 173.117 257.847 173.117Z"
        fill="#19313A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M271.803 165.997C270.164 165.509 268.39 165.885 267.09 166.996C264.509 169.471 263.916 173.373 265.647 176.502C266.79 178.226 268.856 179.094 270.887 178.704C272.47 178.113 273.635 176.745 273.967 175.088C274.732 172.633 274.589 169.985 273.562 167.628C273.232 166.86 272.593 166.268 271.803 165.997Z"
        fill="#19313A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M273.967 175.09C274.156 174.454 274.286 173.802 274.356 173.143C273.352 176.08 270.637 178.091 267.534 178.197C268.556 178.755 269.743 178.935 270.884 178.706C272.469 178.115 273.635 176.748 273.967 175.09Z"
        fill="#002030"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M272.662 167.128C272.103 166.554 271.261 166.357 270.505 166.622C269.749 166.888 269.217 167.569 269.14 168.367C268.811 170.658 270.372 173.169 272.269 173.169C273.529 173.169 274.108 171.977 273.933 170.188C273.897 169.047 273.445 167.958 272.662 167.128Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M198.254 165.361C195.574 163.735 189.014 162.617 184.727 166.818C180.44 171.019 180.751 182.571 188.536 186.464C192.811 188.812 198.082 188.332 201.863 185.252C202.826 177.088 202.861 168.369 198.254 165.361Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M189.713 178.98C189.713 177.428 190.647 176.031 192.079 175.438C193.511 174.845 195.16 175.173 196.255 176.27C197.351 177.366 197.678 179.015 197.084 180.447C196.49 181.879 195.092 182.811 193.542 182.81C191.427 182.809 189.714 181.094 189.713 178.98Z"
        fill="#DD8964"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M193.543 182.804C197.159 182.776 199.934 178.819 199.347 174.066C198.656 168.466 194.092 167.479 191.276 167.636C188.329 167.755 185.958 170.099 185.804 173.044C186.894 170.618 189.643 169.409 192.168 170.244C196.859 171.496 195.343 178.504 193.778 178.976C192.213 179.448 193.543 182.804 193.543 182.804Z"
        fill="#DD8964"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M193.273 164.835C190.53 164.362 187.721 165.173 185.652 167.035C182.894 169.357 182.292 173.006 182.741 176.362C182.753 176.441 182.95 176.57 182.965 176.462C183.454 172.832 184.204 169.132 187.508 166.942C189.267 165.833 191.262 165.155 193.332 164.963C193.417 164.946 193.311 164.844 193.273 164.835Z"
        fill="#FDDEBC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M203.203 186.483C202.691 185.135 202.12 182.811 202.12 182.811C200.91 183.907 199.503 184.762 197.973 185.331C193.805 186.866 189.162 186.396 185.387 184.057C186.281 185.045 187.348 185.861 188.537 186.463C192.001 188.348 196.167 188.422 199.696 186.663C204.862 199.791 212.871 205.274 224.778 210.223C227.884 211.467 231.117 212.364 234.42 212.895C220.044 210.298 208.145 200.23 203.203 186.483Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M243.075 208.638C240.845 208.074 238.707 207.193 236.728 206.021C236.728 206.021 238.065 208.682 242.858 209.782C248.209 211.011 250.915 209.296 250.915 209.296C248.284 209.463 245.642 209.241 243.075 208.638Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M142.162 297.346C142.083 302.597 140.278 316.714 151.112 327.712C161.946 338.71 182.798 334.442 186.981 333.452C190.145 332.858 193.374 332.692 196.581 332.959C198.813 332.914 204.624 331.482 205.61 327.051C205.61 327.051 199.371 330.333 194.775 323.11C189.74 314.606 189.883 304 195.145 295.634C200.022 288.144 210.468 286.521 213.321 286.178C213.321 286.178 212.613 282.779 207.951 282.19C205.407 281.866 198.851 284.914 189.856 287.526C176.397 291.441 158.959 297.651 142.162 297.346Z"
        fill="#4477BB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M197.353 285.567C192.52 287.647 186.89 295.777 185.603 303.207C187.411 298.126 190.32 293.507 194.12 289.681C196.821 286.957 201.738 284.652 202.279 284.195C202.855 283.713 200.587 284.174 197.353 285.567Z"
        fill="#71ABDE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M186.983 333.458C190.146 332.864 193.375 332.698 196.582 332.965C198.814 332.92 204.625 331.488 205.611 327.057C202.615 328.446 199.071 327.825 196.725 325.502L194.369 326.591C194.369 326.591 192.707 330.014 188.919 325.773C183.73 319.963 184.737 307.38 184.737 307.38C182.146 322.35 188.611 328.332 187.794 328.765C186.978 329.198 172.648 332.88 162.72 326.708C152.793 320.537 155.083 302.098 160.494 299.688C165.983 297.248 172.255 295.262 181.728 289.967C169.75 293.579 155.748 297.593 142.163 297.346C142.084 302.598 140.279 316.714 151.113 327.712C161.947 338.711 182.801 334.442 186.983 333.458Z"
        fill="#3E65AE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M198.369 289.296C202.45 287.78 206.719 286.826 211.057 286.461C209.418 284.52 204.292 285.281 198.369 289.296Z"
        fill="#295296"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M213.323 286.184C217.392 285.569 232.989 284.935 241.183 289.622C249.769 294.537 250.854 300.962 250.185 307.984C249.516 315.007 205.616 327.057 205.616 327.057C205.616 327.057 204.204 330.02 199.036 328.97C193.869 327.92 190.146 323.139 188.998 313.388C187.85 303.637 192.439 293.314 198.367 289.299C202.163 286.967 206.628 285.97 211.055 286.464L213.323 286.184Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M218.775 306.09C218.775 306.09 213.089 307.377 204.595 314.616C197.636 320.548 193.877 321.647 191.391 314.962C188.904 308.277 191.163 297.783 195.295 292.076C190.441 298.058 188.174 305.728 188.995 313.387C190.143 323.138 193.871 327.918 199.033 328.969C204.195 330.02 205.613 327.055 205.613 327.055C205.613 327.055 211.007 311.281 218.775 306.09Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M205.609 327.057C203.485 327.913 201.281 328.554 199.029 328.97C204.197 330.02 205.609 327.057 205.609 327.057Z"
        fill="#295296"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M250.179 307.98C249.538 316.977 240.046 350.492 237.971 359.14C236.163 366.679 235.032 371.241 235.032 371.241C223.479 380.386 212.013 385.173 200.638 385.359C200.638 385.359 201.198 366.648 201.198 356.12C201.198 345.592 201.567 336.451 205.17 325.925C206.263 322.727 211.519 310.599 218.78 306.085C228.456 300.075 237.998 305.775 250.179 307.98Z"
        fill="#F8C6A3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M219.18 356.759C210.796 357.886 208.623 356.759 206.844 347.755C205.064 338.752 207.237 321.077 209.868 316.16C207.998 319.263 206.424 322.534 205.165 325.931C201.564 336.457 201.193 345.599 201.193 356.126C201.193 361.807 201.032 369.867 200.884 376.089L208.724 374.999L234.632 368.444C234.632 368.444 235.245 367.918 236.052 367.114C236.543 365.097 237.197 362.401 237.977 359.146C238.03 358.922 238.093 358.666 238.156 358.402C234.288 356.353 226.803 355.734 219.18 356.759Z"
        fill="#F2A37C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M242.2 312.027C239.942 311.341 237.906 310.069 236.299 308.342C234.619 306.402 233.9 303.841 232.969 304.356C231.108 305.388 232.037 312.84 235.866 315.349C238.248 317.158 241.437 317.493 244.142 316.22C245.487 315.539 247.141 313.371 242.2 312.027Z"
        fill="#F2A37C"
      />
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M250.179 307.984C250.848 300.957 249.758 294.536 241.176 289.622C236.587 286.995 229.673 286.04 223.765 285.816C230.272 286.376 244.354 290.551 247.378 299.767C248.147 302.104 248.078 305.982 247.475 311.887C246.061 325.788 241.641 345.067 241.637 345.083C245.154 331.787 249.739 314.143 250.179 307.984Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M235.038 371.245C235.637 368.747 236.553 366.337 237.766 364.072C238.492 363.105 238.492 361.413 234.015 360.444C229.538 359.475 217.554 360.08 208.724 362.985C199.894 365.89 198.199 369.035 198.683 370.365C199.168 371.696 201.278 379.671 200.643 385.364C211.987 385.22 223.456 380.359 235.038 371.245Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M236.975 365.574V365.564C236.975 365.564 228.103 363.554 215.618 366.735C202.792 370.001 199.585 373.779 199.585 373.779C199.865 375.052 200.159 376.56 200.38 378.159C201.952 376.911 206.171 374.239 215.618 371.828C222.019 370.127 228.682 369.635 235.264 370.379C235.731 368.742 236.303 367.137 236.975 365.574V365.574Z"
        fill="#4477BB"
      />
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M216.062 382.329C215.179 381.981 214.193 381.998 213.322 382.378C207.871 384.187 206.654 380.08 206.629 377.302C206.677 374.377 206.268 371.462 205.416 368.663C204.972 367.68 204.951 366.557 205.358 365.558C205.765 364.559 206.565 363.771 207.57 363.379C199.738 366.169 198.213 369.095 198.677 370.366C199.161 371.698 201.271 379.672 200.637 385.364C205.916 385.26 211.136 384.232 216.062 382.329Z"
          fill="#242357"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M210.894 380.865C208.374 382.649 202.58 382.825 200.524 379.293C200.524 379.293 199.602 379.845 198.604 382.729C197.606 385.613 196.41 392.405 198.604 396.068C202.814 393.921 207.28 392.317 211.894 391.297C219.217 389.744 229.315 384.306 232.754 381.977C236.192 379.647 250.619 371.323 261.381 376.539C261.381 376.539 257.72 370.77 247.846 370.88C237.972 370.991 235.035 371.247 235.035 371.247C235.035 371.247 221.978 371.758 215.888 374.543C212.004 376.315 213.557 378.978 210.894 380.865Z"
        fill="#4477BB"
      />
      <g style="mix-blend-mode:multiply" opacity="0.2">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M232.753 381.975C235.343 380.28 238.089 378.836 240.954 377.663C240.293 374.672 239.282 371.712 237.819 371.102C237.319 371.12 236.894 371.139 236.541 371.156H236.526C232.383 373.188 232.116 379.175 232.116 379.175C229.792 379.542 222.316 384.161 219.582 385.359C214.224 387.704 211.215 387.381 209.952 386.468C208.176 385.186 208.29 381.904 208.29 381.904C205.53 382.464 202.025 381.875 200.52 379.29C200.52 379.29 199.598 379.842 198.6 382.726C197.602 385.61 196.406 392.403 198.6 396.065C202.81 393.918 207.275 392.314 211.89 391.294C219.216 389.743 229.313 384.305 232.753 381.975Z"
          fill="#242357"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M261.367 376.525C251.178 371.604 237.717 378.79 233.399 381.552C233.601 381.412 231.871 375.546 236.523 371.161C241.175 366.777 258.707 367.112 261.367 376.525Z"
        fill="#EFF8FC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M261.368 376.52C257.028 368.583 244.69 371.62 241.434 372.898C238.179 374.176 233.926 375.138 234.481 373.824C233.372 376.237 232.996 378.922 233.4 381.547C237.72 378.789 251.181 371.603 261.368 376.52Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M261.371 376.526C259.617 374.551 257.178 373.316 254.549 373.073C248.016 372.422 241.464 374.096 236.045 377.801C230.601 381.36 224.845 384.416 218.847 386.93C213.223 389.375 201.487 390.272 197.925 394.731C197.925 394.731 196.973 396.303 197.245 400.509C197.176 404.099 199.479 407.306 202.903 408.387C206.786 409.939 218.105 410.715 232.196 406.057C246.287 401.399 255.576 400.722 261.378 392.409C266.422 385.178 263.243 378.698 261.371 376.526Z"
        fill="#DEF1F8"
      />
      <mask
        id="mask1"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="197"
        y="372"
        width="68"
        height="38"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M261.371 376.526C259.617 374.551 257.178 373.316 254.549 373.073C248.016 372.422 241.464 374.096 236.045 377.801C230.601 381.36 224.845 384.416 218.847 386.93C213.223 389.375 201.487 390.272 197.925 394.731C197.925 394.731 196.973 396.303 197.245 400.509C197.176 404.099 199.479 407.306 202.903 408.387C206.786 409.939 218.105 410.715 232.196 406.057C246.287 401.399 255.576 400.722 261.378 392.409C266.422 385.178 263.243 378.698 261.371 376.526Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1)">
        <path
          d="M265.442 381.553C263.033 376.818 255.362 372.904 244.696 376.31C233.808 379.786 231.905 384.448 220.309 388.833C208.713 393.218 198.668 391.826 195.63 401.713"
          stroke="#4477BB"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M254.224 377.31C246.666 377.201 239.287 379.61 233.249 384.158C227.968 387.987 222.04 390.833 215.749 392.558C210.276 394.128 207.308 393.942 201.93 396.398C199.082 397.441 197.345 400.326 197.755 403.331C198.562 405.743 200.476 407.624 202.902 408.39C206.786 409.943 218.105 410.718 232.196 406.061C246.287 401.403 255.576 400.725 261.378 392.412C263.642 389.404 264.534 385.581 263.834 381.881C262.692 379.582 261.136 377.473 254.224 377.31Z"
        fill="#E8914F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M211.79 407.575C209.036 407.712 206.28 407.353 203.653 406.516C201.836 405.979 200.378 404.62 199.716 402.845C199.565 400.791 200.818 398.894 202.766 398.225C205.356 397.062 208.085 396.235 210.885 395.765C212.445 395.449 214.212 395.089 216.299 394.49C222.821 392.708 228.965 389.758 234.434 385.783C239.924 381.644 246.598 379.377 253.474 379.316C253.703 379.316 253.934 379.316 254.164 379.325C260.044 379.465 261.144 381.047 261.904 382.529C262.397 385.616 261.608 388.769 259.72 391.26C255.673 397.063 249.702 398.782 240.664 401.386C237.942 402.169 234.856 403.058 231.564 404.15C225.195 406.333 218.519 407.491 211.787 407.581L211.79 407.575Z"
        fill="#D1783B"
      />
      <mask
        id="mask2"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="199"
        y="379"
        width="64"
        height="29"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M211.789 407.575C209.035 407.712 206.279 407.353 203.652 406.516C201.835 405.979 200.377 404.62 199.715 402.845C199.564 400.791 200.817 398.894 202.765 398.225C205.355 397.062 208.084 396.235 210.884 395.765C212.444 395.449 214.211 395.089 216.298 394.49C222.82 392.708 228.964 389.758 234.433 385.783C239.923 381.644 246.597 379.377 253.473 379.316C253.702 379.316 253.933 379.316 254.163 379.325C260.043 379.465 261.143 381.047 261.903 382.529C262.396 385.616 261.607 388.769 259.719 391.26C255.672 397.063 249.701 398.782 240.663 401.386C237.941 402.169 234.855 403.058 231.563 404.15C225.194 406.333 218.518 407.491 211.786 407.581L211.789 407.575Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M257.363 396.387L259.572 379.633L260.902 379.808L258.693 396.563L257.363 396.387Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M251.669 399.689L254.464 378.484L255.794 378.66L252.999 399.864L251.669 399.689Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M246.181 401.598L249.029 379.672L250.359 379.845L247.511 401.771L246.181 401.598Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M240.664 403.251L243.78 380.365L245.107 380.546L241.992 403.432L240.664 403.251Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M235.199 405.004L237.973 383.342L239.303 383.512L236.53 405.175L235.199 405.004Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M229.815 405.78L232.328 386.738L233.657 386.914L231.145 405.955L229.815 405.78Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M224.378 407.298L226.586 390.545L227.916 390.72L225.708 407.473L224.378 407.298Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M218.848 408.879L221.056 392.125L222.386 392.3L220.177 409.055L218.848 408.879Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M213.613 409.043L215.574 394.172L216.903 394.347L214.943 409.218L213.613 409.043Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M208.358 408.78L210.104 395.541L211.433 395.716L209.688 408.955L208.358 408.78Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M203.23 407.469L204.634 396.83L205.964 397.006L204.56 407.644L203.23 407.469Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M200.121 400.118L200.644 398.885L221.976 407.924L221.454 409.158L200.121 400.118Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M207.835 396.815L208.352 395.578L232.005 405.47L231.487 406.706L207.835 396.815Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M218.448 394.111L218.983 392.883L241.598 402.728L241.064 403.956L218.448 394.111Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M226.148 390.793L226.672 389.561L250.584 399.723L250.06 400.956L226.148 390.793Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M233.146 386.641L233.683 385.414L257.55 395.863L257.012 397.091L233.146 386.641Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M239.492 382.997L240.014 381.762L262.557 391.28L262.036 392.516L239.492 382.997Z"
          fill="#C66D32"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M248.447 379.927L248.969 378.691L264.291 385.163L263.769 386.398L248.447 379.927Z"
          fill="#C66D32"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M261.916 382.523C261.853 382.401 261.786 382.278 261.716 382.156C261.677 384.643 260.862 387.055 259.383 389.055C255.337 394.858 249.366 396.579 240.326 399.182C237.605 399.966 234.519 400.853 231.226 401.945C224.858 404.13 218.182 405.288 211.45 405.377C208.696 405.513 205.94 405.155 203.313 404.317C201.839 403.844 200.586 402.856 199.781 401.534C199.685 401.964 199.667 402.408 199.726 402.845C200.388 404.62 201.846 405.98 203.663 406.516C206.29 407.353 209.046 407.712 211.8 407.576C218.532 407.486 225.208 406.328 231.576 404.145C234.876 403.053 237.961 402.165 240.676 401.381C249.715 398.777 255.686 397.057 259.733 391.255C261.62 388.763 262.409 385.609 261.916 382.523Z"
        fill="#C66D32"
      />
      <path d="M259.627 379.311L256.827 396.066" stroke="#E8914F" />
      <path d="M253.935 378.162L251.135 399.368" stroke="#E8914F" />
      <path d="M248.498 379.35L245.629 401.272" stroke="#E8914F" />
      <path d="M243.233 380.045L240.126 402.932" stroke="#E8914F" />
      <path d="M237.461 383.018L234.661 404.678" stroke="#E8914F" />
      <path d="M232.081 386.418L229.281 405.461" stroke="#E8914F" />
      <path d="M226.643 390.223L223.843 406.978" stroke="#E8914F" />
      <path d="M221.112 391.803L218.312 408.558" stroke="#E8914F" />
      <path d="M215.876 393.85L213.076 408.722" stroke="#E8914F" />
      <path d="M210.622 395.219L207.822 408.459" stroke="#E8914F" />
      <path d="M205.493 396.506L202.693 407.146" stroke="#E8914F" />
      <path d="M199.176 399.092L220.509 408.132" stroke="#E8914F" />
      <path d="M206.887 395.787L230.53 405.671" stroke="#E8914F" />
      <path d="M217.509 393.088L240.126 402.933" stroke="#E8914F" />
      <path d="M225.203 389.768L249.121 399.94" stroke="#E8914F" />
      <path d="M232.21 385.617L256.077 396.065" stroke="#E8914F" />
      <path d="M238.547 381.969L261.091 391.487" stroke="#E8914F" />
      <path d="M247.5 378.898L262.829 385.362" stroke="#E8914F" />
      <circle cx="430.015" cy="136.866" r="35.2368" fill="#7A60A6" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M464.303 128.775C462.357 120.499 457.47 113.211 450.552 108.27C450.798 109.096 455.558 125.802 442.012 142.679C428.432 159.602 403.687 158.931 402.585 158.892C412.881 171.722 430.692 175.71 445.476 168.495C460.26 161.28 468.075 144.786 464.297 128.775H464.303Z"
        fill="#6D5298"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M461.672 128.805C464.936 142.663 458.865 157.042 446.657 164.367C434.449 171.693 418.905 170.285 408.212 160.884C421.174 167.44 436.846 165.232 447.492 155.35C458.138 145.468 461.506 130.003 455.932 116.59C458.677 120.216 460.633 124.377 461.672 128.805H461.672Z"
        fill="#5F4589"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M399.587 133.506C398.187 127.561 401.873 121.606 407.819 120.207C413.764 118.807 419.719 122.493 421.118 128.439C422.518 134.384 418.832 140.339 412.887 141.738C410.031 142.411 407.026 141.921 404.532 140.377C402.038 138.833 400.259 136.362 399.587 133.506Z"
        fill="#F298BB"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M402.085 129.732C401.494 127.222 402.473 124.603 404.566 123.096C406.659 121.589 409.453 121.492 411.646 122.849C413.839 124.206 414.998 126.75 414.584 129.296C414.169 131.841 412.262 133.886 409.752 134.476C406.325 135.282 402.893 133.158 402.085 129.732Z"
        fill="#F298BB"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M426.88 119.868C425.48 113.922 429.166 107.968 435.112 106.568C441.057 105.169 447.012 108.854 448.411 114.8C449.811 120.746 446.125 126.7 440.18 128.1C437.324 128.772 434.319 128.282 431.825 126.738C429.33 125.195 427.552 122.723 426.88 119.868Z"
        fill="#F298BB"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M430.125 115.468C429.573 113.123 430.487 110.677 432.442 109.27C434.396 107.863 437.006 107.772 439.054 109.04C441.102 110.307 442.184 112.683 441.797 115.06C441.41 117.437 439.629 119.347 437.284 119.899C434.084 120.652 430.878 118.668 430.125 115.468Z"
        fill="#F298BB"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M413.272 113.318C412.763 111.168 413.601 108.923 415.394 107.631C417.186 106.34 419.581 106.256 421.459 107.419C423.338 108.582 424.331 110.763 423.974 112.944C423.617 115.124 421.981 116.875 419.829 117.378C418.421 117.709 416.939 117.468 415.71 116.706C414.48 115.945 413.603 114.726 413.272 113.318Z"
        fill="#F298BB"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M414.467 111.965C414.193 110.807 414.644 109.598 415.609 108.903C416.574 108.207 417.864 108.162 418.876 108.788C419.887 109.415 420.422 110.589 420.229 111.763C420.037 112.938 419.155 113.88 417.996 114.151C416.419 114.519 414.84 113.542 414.467 111.965Z"
        fill="#F298BB"
      />
      <path
        opacity="0.15"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M441.67 108.278C437.418 106.021 421.389 102.935 409.427 115.278C399.681 125.463 397.579 140.757 404.218 153.193C403.205 148.887 402.86 133.873 412.271 122.476C421.682 111.078 435.34 108.897 441.67 108.278Z"
        fill="#D6B6D8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M441.668 108.279C441.668 108.279 422.201 102.366 409.599 117.043C396.996 131.719 402.792 150.762 404.218 153.186C404.218 153.186 392.351 133.088 407.881 115.539C422.379 99.1561 441.668 108.279 441.668 108.279Z"
        fill="#D7CEE7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M490.806 171.572C488.888 175.614 473.188 172.454 451.915 164.443C443.129 161.132 433.385 156.99 423.27 152.19C412.793 147.218 403.109 142.104 394.792 137.23C375.649 126.022 363.66 116.1 365.553 112.114C367.351 108.334 381.208 110.863 400.413 117.765C399.754 118.79 399.146 119.848 398.593 120.934C390.802 118.687 385.639 118.168 384.816 119.904C383.951 121.724 388.036 125.683 395.341 130.622C405.003 136.915 415.102 142.509 425.562 147.362C435.63 152.236 446.018 156.42 456.654 159.886C465.643 162.679 471.701 163.465 472.599 161.575C473.453 159.772 469.456 155.868 462.274 150.992C462.756 149.894 463.182 148.773 463.552 147.632C481.539 158.358 492.63 167.729 490.806 171.572Z"
        fill="#D5E9F9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M490.001 172.702C488.081 176.743 472.382 173.584 451.11 165.573C442.322 162.262 432.58 158.119 422.463 153.32C411.987 148.347 402.303 143.233 393.986 138.36C374.841 127.151 362.854 117.229 364.745 113.244C366.543 109.464 380.484 112.04 399.685 118.94C399.064 119.968 398.506 121.033 398.014 122.128C390.223 119.88 384.833 119.296 384.014 121.032C383.15 122.852 387.234 126.811 394.54 131.75C404.202 138.043 414.301 143.638 424.761 148.49C434.83 153.364 445.217 157.548 455.853 161.014C464.843 163.807 470.901 164.593 471.799 162.703C472.653 160.9 468.869 157.124 461.686 152.248C462.167 151.15 462.726 150.11 463.095 148.969C481.078 159.693 491.825 168.86 490.001 172.702Z"
        fill="#F49639"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M490.806 171.572C488.888 175.614 473.188 172.454 451.915 164.443C443.129 161.132 433.385 156.99 423.27 152.19C412.793 147.218 403.109 142.104 394.792 137.23C375.649 126.022 363.66 116.1 365.553 112.114C367.351 108.334 381.208 110.863 400.413 117.765C399.754 118.79 399.146 119.848 398.593 120.934C390.802 118.687 385.639 118.168 384.816 119.904C383.951 121.724 388.036 125.683 395.341 130.622C405.003 136.915 415.102 142.509 425.562 147.362C435.63 152.236 446.018 156.42 456.654 159.886C465.643 162.679 471.701 163.465 472.599 161.575C473.453 159.772 469.456 155.868 462.274 150.992C462.756 149.894 463.182 148.773 463.552 147.632C481.539 158.358 492.63 167.729 490.806 171.572Z"
        fill="#FFE568"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M482.519 161.503C486.098 164.978 491.909 169.063 489.014 171.5C486.119 173.938 463.394 169.54 420.166 149.434C420.166 149.434 464.057 166.42 475.404 168.416C486.662 170.396 488.242 168.874 482.519 161.503Z"
        fill="#FCC231"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M386.266 114.076C381.482 113.108 369.69 110.217 367.429 112.415C365.168 114.613 378.654 126.109 383.522 128.851C383.522 128.851 371.423 119.085 370.9 114.581C370.508 111.218 386.266 114.076 386.266 114.076Z"
        fill="#FFEDB2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M398.492 119.595C395.461 118.654 392.371 117.908 389.244 117.363C384.786 116.655 379.465 115.948 380.012 118.979C380.56 122.01 384.62 125.728 392.843 131.439C401.067 137.15 414.952 144.955 414.952 144.955C414.952 144.955 394.628 134.749 386.844 129.289C379.06 123.829 374.362 118.31 375.448 115.934C376.804 112.97 389.139 114.954 399.061 118.874L398.492 119.595Z"
        fill="#FFDA60"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.6282 178.883C95.6282 178.883 59.4466 184.188 30.1642 173.814C29.3447 173.519 28.8963 172.638 29.1408 171.802C29.6252 170.14 30.44 167.214 31.2408 163.745C33.1127 155.652 95.6282 178.883 95.6282 178.883Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.24 163.745C30.7444 165.89 30.2445 167.826 29.8203 169.387C59.0593 180.983 95.6203 178.883 95.6203 178.883C95.6203 178.883 33.1103 155.652 31.24 163.745Z"
        fill="#8CB8BF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.1988 129.658C37.1988 129.658 37.4787 145.408 33.1724 153.509C28.8661 161.609 80.8746 179.705 95.6291 178.885C95.6291 178.885 75.3782 161.822 64.2691 148.173C57.0609 139.695 47.7136 133.302 37.1988 129.658Z"
        fill="#CCE4EA"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M33.1721 153.509C28.8685 161.609 80.8743 179.705 95.6288 178.885C72.0599 171.325 39.7787 144.518 39.7787 144.518C39.5999 139.47 38.7318 134.471 37.1985 129.658C37.1985 129.658 37.4757 145.408 33.1721 153.509Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.3356 134C19.8291 134.271 12.8207 135.436 5.41485 136.083C-5.71371 137.055 -15.3177 135.152 -14.0703 138.135C-12.9572 140.795 4.42791 157.86 29.3787 167.227C54.3296 176.595 85.5033 179.687 95.6282 178.882C81.2733 173.582 67.4462 166.949 54.3282 159.07C33.6808 146.489 25.6574 133.217 21.3356 134Z"
        fill="#F7FCFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.6288 178.884C95.6288 178.884 82.0152 164.834 74.0911 149.546C63.7143 129.517 61.2517 114.151 60.1526 112.684C59.0536 111.216 54.4322 114.728 47.0514 120.384C43.5126 123.192 40.2165 126.294 37.1982 129.656C37.1982 129.656 72.2627 170.807 95.6288 178.884Z"
        fill="#F7FCFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.7789 137.141C3.7697 140.144 -10.7637 137.681 -7.41064 141.8C-4.05762 145.919 29.0594 171.506 76.434 175.733C76.434 175.733 35.0361 165.436 16.71 154.282C-4.82205 141.178 3.15789 141.338 6.56423 140.562C9.80549 139.945 12.9203 138.789 15.7789 137.141Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.8136 174.386C88.8136 174.386 56.5869 149.486 40.7236 130.254C40.7236 130.254 47.3036 121.398 55.5077 117.016C55.5077 117.016 48.7275 123.206 46.6625 127.236C45.7063 129.103 47.5977 133.029 50.7911 137.142C58.3581 146.893 88.8136 174.386 88.8136 174.386Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M390.631 237.267C390.631 237.267 363.674 248.838 338.831 246.832C338.135 246.773 337.605 246.181 337.623 245.483C337.656 244.094 337.683 241.658 337.59 238.805C337.376 232.142 390.631 237.267 390.631 237.267Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M337.596 238.802C337.654 240.567 337.665 242.171 337.658 243.468C362.718 246.43 390.631 237.266 390.631 237.266C390.631 237.266 337.377 232.14 337.596 238.802Z"
        fill="#8CB8BF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M335.188 211.148C335.188 211.148 338.651 223.301 336.983 230.469C335.316 237.636 379.364 240.942 390.633 237.265C390.633 237.265 371.416 228.212 359.994 219.919C352.657 214.833 344.092 211.804 335.188 211.148Z"
        fill="#CCE4EA"
      />
      <path
        opacity="0.5"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M336.983 230.469C335.317 237.635 379.364 240.942 390.633 237.265C370.804 236.267 340.251 222.136 340.251 222.136C339.072 218.26 337.369 214.563 335.188 211.148C335.188 211.148 338.651 223.299 336.983 230.469Z"
        fill="#A9CBD3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M323.79 217.785C322.678 218.307 317.49 220.654 311.877 222.685C303.45 225.733 295.613 226.237 297.195 228.294C298.606 230.128 315.602 239.774 336.875 241.89C358.148 244.007 382.955 239.982 390.635 237.27C378.415 236.12 366.328 233.827 354.535 230.423C335.929 224.917 326.975 216.287 323.79 217.785Z"
        fill="#F7FCFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M390.633 237.267C390.633 237.267 377.183 229.18 367.887 218.957C355.714 205.571 350.639 194.165 349.483 193.253C348.326 192.342 345.47 196.018 340.916 201.933C338.751 204.84 336.835 207.925 335.188 211.154C335.189 211.154 370.855 235.82 390.633 237.267Z"
        fill="#F7FCFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M320.126 221.365C311.436 226.167 299.66 227.255 303.109 229.757C306.557 232.259 337.505 245.267 375.102 238.78C375.102 238.78 340.888 239.333 324.382 234.462C304.986 228.742 311.208 227.221 313.687 225.912C316.073 224.768 318.249 223.231 320.126 221.365Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M384.421 235.181C384.421 235.181 354.305 222.523 338.043 210.882C338.043 210.882 341.323 202.658 346.776 197.57C346.776 197.57 342.796 203.767 342.026 207.316C341.669 208.961 343.944 211.615 347.268 214.145C355.144 220.145 384.421 235.181 384.421 235.181Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.58398 236.198H-10.4608C-11.6073 226.683 -19.6782 219.524 -29.2613 219.519V210.685C-29.2649 199.907 -38.0007 191.176 -48.7742 191.178L-48.7689 191.178C-59.5426 191.178 -68.2764 199.912 -68.2764 210.685V216.456C-71.0169 210.88 -77.2412 207.93 -83.2926 209.34C-89.3439 210.751 -93.6232 216.148 -93.6162 222.361L-93.6164 236.199H-110.044C-113.272 236.2 -115.888 238.816 -115.888 242.044H-115.888C-115.888 245.27 -113.272 247.886 -110.046 247.888H3.58279C6.81038 247.888 9.427 245.272 9.42786 242.044C9.42854 240.495 8.81349 239.008 7.71768 237.911C6.62206 236.815 5.13558 236.198 3.58536 236.198H3.58398Z"
        fill="white"
      />
      <circle
        cx="267.534"
        cy="80.5234"
        r="10.2578"
        fill="white"
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M267.534 92.5444C266.577 92.5444 265.801 91.7687 265.8 90.8112V70.2313C265.8 69.2738 266.577 68.498 267.534 68.498C267.994 68.498 268.435 68.6806 268.76 69.0057C269.085 69.3307 269.268 69.7715 269.268 70.2313V90.8112C269.267 91.2718 269.085 91.7125 268.759 92.0374C268.434 92.3623 267.993 92.5447 267.534 92.5444H267.534Z"
        fill="white"
        fill-opacity="0.298039"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M279.555 80.5223C279.555 81.4797 278.779 82.2561 277.822 82.2568H257.242C256.285 82.2561 255.509 81.4797 255.509 80.5223C255.509 80.0617 255.692 79.621 256.017 79.2961C256.342 78.9712 256.783 78.7888 257.243 78.7891H277.822C278.282 78.7891 278.722 78.9717 279.047 79.2967C279.373 79.6217 279.555 80.0626 279.555 80.5223Z"
        fill="white"
        fill-opacity="0.298039"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M274.81 80.5209C274.81 81.4789 274.033 82.2555 273.075 82.2554H261.991C261.033 82.2555 260.257 81.4789 260.257 80.5209C260.258 79.564 261.035 78.7891 261.991 78.7891H273.075C274.032 78.7891 274.808 79.564 274.81 80.5209Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M267.534 87.7989C266.576 87.7989 265.8 87.0223 265.8 86.0642V74.9749C265.8 74.0168 266.576 73.2402 267.534 73.2402C268.492 73.241 269.268 74.0174 269.268 74.9749V86.0586C269.269 86.5195 269.087 86.9619 268.762 87.2884C268.437 87.6148 267.995 87.7985 267.534 87.7989Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M329.657 150.017C329.657 148.49 330.895 147.252 332.422 147.252C333.949 147.252 335.187 148.489 335.187 150.016C335.188 151.543 333.95 152.781 332.424 152.782C331.69 152.782 330.986 152.491 330.467 151.973C329.949 151.454 329.657 150.751 329.657 150.017Z"
        fill="#FFEDB2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M145.073 68.5033C145.074 67.384 145.748 66.3761 146.781 65.9484C147.814 65.5209 149.004 65.7578 149.794 66.5489C150.585 67.3399 150.821 68.5293 150.392 69.5624C149.964 70.5954 148.956 71.2688 147.837 71.2683C146.311 71.2679 145.073 70.0301 145.073 68.5033Z"
        fill="#FFEDB2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M133.514 139.487C133.513 138.368 134.187 137.359 135.22 136.93C136.254 136.501 137.444 136.737 138.236 137.528C139.027 138.319 139.264 139.509 138.836 140.543C138.408 141.577 137.399 142.252 136.28 142.252C135.547 142.252 134.843 141.961 134.324 141.442C133.805 140.924 133.514 140.22 133.514 139.487Z"
        fill="#FFEDB2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M299.728 62.6844C299.727 61.5665 300.401 60.5575 301.434 60.129C302.468 59.7005 303.658 59.9367 304.449 60.7276C305.241 61.5186 305.478 62.7084 305.05 63.7422C304.622 64.7761 303.614 65.4505 302.495 65.4508C301.761 65.4511 301.057 65.1597 300.538 64.6409C300.019 64.122 299.728 63.4183 299.728 62.6844Z"
        fill="#FFEDB2"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="131.947"
        y1="324.641"
        x2="131.947"
        y2="432.798"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F59D10" stop-opacity="0.501961" />
        <stop offset="0.144" stop-color="#F59D10" stop-opacity="0.470588" />
        <stop offset="0.361" stop-color="#F59D12" stop-opacity="0.384314" />
        <stop offset="0.624" stop-color="#F69E16" stop-opacity="0.247059" />
        <stop offset="0.921" stop-color="#F69F1B" stop-opacity="0.054902" />
        <stop offset="1" stop-color="#F7A01D" stop-opacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="246.87"
        y1="182.318"
        x2="246.87"
        y2="154.672"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F2A37C" />
        <stop offset="0.09" stop-color="#F2A47D" stop-opacity="0.968627" />
        <stop offset="0.225" stop-color="#F2A780" stop-opacity="0.882353" />
        <stop offset="0.39" stop-color="#F3AC86" stop-opacity="0.741176" />
        <stop offset="0.577" stop-color="#F4B28D" stop-opacity="0.54902" />
        <stop offset="0.783" stop-color="#F6BB97" stop-opacity="0.298039" />
        <stop offset="1" stop-color="#F8C6A3" stop-opacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="274.056"
        y1="179.99"
        x2="274.056"
        y2="154.626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F2A37C" />
        <stop offset="0.09" stop-color="#F2A47D" stop-opacity="0.968627" />
        <stop offset="0.225" stop-color="#F2A780" stop-opacity="0.882353" />
        <stop offset="0.39" stop-color="#F3AC86" stop-opacity="0.741176" />
        <stop offset="0.577" stop-color="#F4B28D" stop-opacity="0.54902" />
        <stop offset="0.783" stop-color="#F6BB97" stop-opacity="0.298039" />
        <stop offset="1" stop-color="#F8C6A3" stop-opacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "student-image"
};
</script>

<style lang="scss" scoped></style>
